import { useState, useEffect, useCallback, useRef } from "react";

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(()=>{}); });
}

const SB_URL = "https://lqnfkimcoqzlbegyuxnj.supabase.co";
const SB_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxxbmZraW1jb3F6bGJlZ3l1eG5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUxNDI3MDEsImV4cCI6MjEwMDcxODcwMX0.aPeKRH_D6v8JDpzCaaji8GIeV2s06qxfIwdj-OJDndE";
const getToken = () => localStorage.getItem("wf_token") || SB_KEY;

const sb = async (path, method="GET", body=null) => {
  const token = getToken();
  const res = await fetch(`${SB_URL}/rest/v1/${path}`, {
    method,
    headers: { apikey:SB_KEY, Authorization:`Bearer ${token}`, "Content-Type":"application/json", Prefer:"return=representation" },
    body: body ? JSON.stringify(body) : null,
  });
  const text = await res.text();
  if (!res.ok) {
    const err = text ? JSON.parse(text) : {};
    // JWT expired — clear and force re-login
    if (err.message==="JWT expired" || res.status===401) {
      localStorage.removeItem("wf_token");
      localStorage.removeItem("wf_user");
      window.location.reload();
      return [];
    }
    throw new Error(text);
  }
  return text ? JSON.parse(text) : [];
};

const sbAuth = async (endpoint, body) => {
  const res = await fetch(`${SB_URL}/auth/v1/${endpoint}`, {
    method:"POST",
    headers: { apikey:SB_KEY, "Content-Type":"application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error_description||data.msg||"Auth error");
  return data;
};

const C = { accent:"#6C63FF",success:"#22C55E",warning:"#F59E0B",danger:"#EF4444",purple:"#A78BFA",bg:"#0D0F1A",surface:"#161929",card:"#1C2035",border:"#252A40",muted:"#6B7280",text:"#F0F0F8" };
const CL = { accent:"#6C63FF",success:"#22C55E",warning:"#F59E0B",danger:"#EF4444",purple:"#A78BFA",bg:"#F4F5FB",surface:"#FFFFFF",card:"#ECEEF8",border:"#D1D5DB",muted:"#6B7280",text:"#111827" };
const STATUS_FLOW = ["Not Started","Started","In Progress","Sent","Completed"];
const STATUS_COLOR = { "Not Started":"#6B7280","Started":"#38BDF8","In Progress":"#F59E0B","Sent":"#A78BFA","Completed":"#22C55E" };
const DEFAULT_CATEGORIES = ["Reel","Logo","Poster","Website","Visiting Card","Video Edit","Photo Edit","Content","Other"];
const TAGS = ["Urgent","VIP","Monthly","One Time","Repeat Client","High Priority","Design","Marketing"];
const PRIORITIES = ["Low","Medium","High"];
const PRIORITY_COLOR = { Low:"#22C55E",Medium:"#F59E0B",High:"#EF4444" };
const PRIORITY_STARS = { Low:1,Medium:2,High:3 };
const SORT_OPTIONS = ["Newest","Oldest","Deadline","Priority","Amount","Status"];
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const WA_TEMPLATES = {
  "Started":(t,c)=>`Hi ${c}, aapka *${t}* shuru ho gaya! 🚀`,
  "In Progress":(t,c)=>`Hi ${c}, *${t}* par kaam chal raha hai ✅`,
  "Sent":(t,c)=>`Hi ${c}, *${t}* bhej diya gaya hai 📤`,
  "Completed":(t,c)=>`Hi ${c}, *${t}* complete! Payment confirm karein 🎉`,
  "Revision":(t,c)=>`Hi ${c}, *${t}* mein revision ho gaya 🔄`,
};

const fmt = iso => iso ? new Date(iso).toLocaleString("en-IN",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}) : "";
const fmtDate = d => d ? new Date(d).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}) : "";
const todayStr = () => new Date().toDateString();
const isOverdue = (dl,st) => dl && st!=="Completed" && new Date(dl)<new Date();
const lsGet = (k,def) => { try { const v=localStorage.getItem(k); return v?JSON.parse(v):def; } catch { return def; } };
const lsSet = (k,v) => { try { localStorage.setItem(k,JSON.stringify(v)); } catch {} };

function useBreakpoint() {
  const [w,setW] = useState(window.innerWidth);
  useEffect(()=>{ const fn=()=>setW(window.innerWidth); window.addEventListener("resize",fn); return ()=>window.removeEventListener("resize",fn); },[]);
  return { isMobile:w<768,isTablet:w>=768&&w<1024,isDesktop:w>=1024,w };
}

// ── Logo Component ────────────────────────────────────────────────────────────
function Logo({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="44" height="44" rx="10" fill="#6C63FF"/>
      <rect x="10" y="12" width="24" height="6" rx="2" fill="white"/>
      <rect x="10" y="21" width="18" height="6" rx="2" fill="white" opacity="0.8"/>
      <rect x="10" y="30" width="12" height="6" rx="2" fill="white" opacity="0.55"/>
    </svg>
  );
}

function LoginScreen({ onLogin }) {
  const [email,setEmail]=useState(""); const [pass,setPass]=useState("");
  const [mode,setMode]=useState("login"); const [loading,setLoading]=useState(false);
  const [err,setErr]=useState(""); const [showPass,setShowPass]=useState(false);
  const inp = {background:C.card,border:`1px solid ${C.border}`,borderRadius:10,color:C.text,padding:"12px 14px",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  const handle = async () => {
    if(!email||!pass){setErr("Fill all fields");return;}
    setLoading(true);setErr("");
    try {
      const data = await sbAuth(mode==="login"?"token?grant_type=password":"signup",{email,password:pass});
      if(data.access_token){
        localStorage.setItem("wf_token",data.access_token);
        if(data.refresh_token)localStorage.setItem("wf_refresh",data.refresh_token);
        localStorage.setItem("wf_user",JSON.stringify(data.user));
        onLogin(data.user);
      }
      else if(mode==="signup"){setErr("Check email to confirm, then login.");setMode("login");}
    } catch(e){setErr(e.message);} finally{setLoading(false);}
  };
  return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'Inter',system-ui,sans-serif"}}>
      <div style={{width:"100%",maxWidth:380}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{margin:"0 auto 16px",width:60,height:60}}>
            <Logo size={60}/>
          </div>
          <div style={{color:C.text,fontWeight:900,fontSize:28,letterSpacing:"-0.5px"}}>Workflow</div>
          <div style={{color:C.muted,fontSize:13,marginTop:4}}>Freelancer Project Management</div>
        </div>
        <div style={{background:C.surface,borderRadius:16,padding:28,border:`1px solid ${C.border}`}}>
          <div style={{color:C.text,fontWeight:800,fontSize:18,marginBottom:20}}>{mode==="login"?"Welcome back 👋":"Create account"}</div>
          <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:16}}>
            <input style={inp} placeholder="Email address" type="email" value={email} onChange={e=>setEmail(e.target.value)}/>
            <div style={{position:"relative"}}>
              <input style={{...inp,paddingRight:44}} placeholder="Password" type={showPass?"text":"password"} value={pass} onChange={e=>setPass(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()}/>
              <button onClick={()=>setShowPass(s=>!s)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:14}}>{showPass?"🙈":"👁️"}</button>
            </div>
          </div>
          {err&&<div style={{background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:8,padding:"10px 14px",color:C.danger,fontSize:13,marginBottom:14}}>{err}</div>}
          <button onClick={handle} disabled={loading} style={{width:"100%",background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"13px",fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1,marginBottom:10}}>
            {loading?"Please wait…":mode==="login"?"Sign In →":"Create Account →"}
          </button>
          {mode==="login"&&<button onClick={async()=>{if(!email){setErr("Enter email first");return;}try{await sbAuth("recover",{email});setErr("Reset email sent!");}catch(e){setErr(e.message);}}} style={{width:"100%",background:"none",border:"none",color:C.muted,fontSize:12,cursor:"pointer",marginBottom:10}}>Forgot password?</button>}
          <div style={{textAlign:"center",color:C.muted,fontSize:13}}>
            {mode==="login"?"No account? ":"Have account? "}
            <button onClick={()=>{setMode(m=>m==="login"?"signup":"login");setErr("");}} style={{background:"none",border:"none",color:C.accent,fontWeight:700,cursor:"pointer",fontSize:13}}>{mode==="login"?"Sign Up":"Sign In"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [user,setUser]=useState(null);
  const [authChecked,setAuthChecked]=useState(false);
  const [profile,setProfile]=useState(null);
  const [dark,setDark]=useState(()=>lsGet("wf_dark",true));
  const T=dark?C:CL; const bp=useBreakpoint();
  const [clients,setClients]=useState([]); const [works,setWorks]=useState([]);
  const [loading,setLoading]=useState(true); const [view,setView]=useState("dashboard");
  const [activeClient,setActiveClient]=useState(null); const [activeWork,setActiveWork]=useState(null);
  const [searchQ,setSearchQ]=useState(""); const [showSearch,setShowSearch]=useState(false);
  const [toast,setToast]=useState(null); const [modal,setModal]=useState(null);
  const [showQuickAdd,setShowQuickAdd]=useState(false);
  const [installPrompt,setInstallPrompt]=useState(null); const [showInstallBanner,setShowInstallBanner]=useState(false);
  const [analyticsMonth,setAnalyticsMonth]=useState(new Date().getMonth());
  const [selectedWorks,setSelectedWorks]=useState([]); const [bulkMode,setBulkMode]=useState(false);
  const [sortBy,setSortBy]=useState("Newest"); const [filterStatus,setFilterStatus]=useState("All"); const [filterPriority,setFilterPriority]=useState("All");
  const [pinnedNotes,setPinnedNotes]=useState(()=>lsGet("wf_pinned",[]));
  const [customCategories,setCustomCategories]=useState(()=>lsGet("wf_cats",DEFAULT_CATEGORIES));
  const [businessProfile,setBusinessProfile]=useState(()=>lsGet("wf_biz",{name:"",tagline:"",phone:"",email:"",address:"",gstin:""}));
  const [timeTrackers,setTimeTrackers]=useState(()=>lsGet("wf_timers",{}));
  const [accentColor,setAccentColor]=useState(()=>lsGet("wf_accent","#6C63FF"));
  const [currency,setCurrency]=useState(()=>lsGet("wf_currency","INR (₹)"));
  const [dateFormat,setDateFormat]=useState(()=>lsGet("wf_datefmt","DD/MM/YYYY"));
  const [notifPrefs,setNotifPrefs]=useState(()=>lsGet("wf_notif",{overdue:true,payment:true,revision:false,delivered:false,completed:false}));
  const [invoiceDefaults,setInvoiceDefaults]=useState(()=>lsGet("wf_invoice",{dueDays:"7",upiId:"",bankName:"",accountNo:"",ifsc:"",terms:"",footer:"Thank you for your business!"}));
  const [defaultView,setDefaultView]=useState(()=>lsGet("wf_view","list"));
  const [waTemplates,setWaTemplates]=useState(()=>lsGet("wf_wa",{"Started":"Hi {client}, aapka *{work}* shuru ho gaya! 🚀","In Progress":"Hi {client}, *{work}* par kaam chal raha hai ✅","Sent":"Hi {client}, *{work}* bhej diya gaya hai. Check karein 📤","Completed":"Hi {client}, *{work}* complete! Payment confirm karein 🎉","Revision":"Hi {client}, *{work}* mein revision ho gaya 🔄","Delivered":"Hi {client}, *{work}* deliver ho gaya hai 📦"}));
  const [workTemplates,setWorkTemplates]=useState(()=>lsGet("wf_tpl",[]));
  const [showOnboarding,setShowOnboarding]=useState(()=>!lsGet("wf_onboarded",false));

  useEffect(()=>{lsSet("wf_dark",dark);},[dark]);
  useEffect(()=>{lsSet("wf_pinned",pinnedNotes);},[pinnedNotes]);
  useEffect(()=>{lsSet("wf_cats",customCategories);},[customCategories]);
  useEffect(()=>{lsSet("wf_biz",businessProfile);},[businessProfile]);
  useEffect(()=>{lsSet("wf_timers",timeTrackers);},[timeTrackers]);

  // Real-time clock — re-check overdue every minute
  const [,setTick]=useState(0);
  useEffect(()=>{
    const t=setInterval(()=>setTick(n=>n+1),60000);
    return ()=>clearInterval(t);
  },[]);

  useEffect(()=>{
    const h=e=>{e.preventDefault();setInstallPrompt(e);setShowInstallBanner(true);};
    window.addEventListener('beforeinstallprompt',h);
    return ()=>window.removeEventListener('beforeinstallprompt',h);
  },[]);

  useEffect(()=>{
    const token=localStorage.getItem("wf_token");
    const savedUser=localStorage.getItem("wf_user");
    const refreshTok=localStorage.getItem("wf_refresh");

    if(token&&savedUser){
      try{
        // Check expiry
        const payload=JSON.parse(atob(token.split('.')[1]));
        const expired=payload.exp*1000<Date.now();
        if(expired&&refreshTok){
          // Auto refresh
          fetch(`${SB_URL}/auth/v1/token?grant_type=refresh_token`,{
            method:"POST",headers:{apikey:SB_KEY,"Content-Type":"application/json"},
            body:JSON.stringify({refresh_token:refreshTok})
          }).then(r=>r.json()).then(data=>{
            if(data.access_token){
              localStorage.setItem("wf_token",data.access_token);
              if(data.refresh_token)localStorage.setItem("wf_refresh",data.refresh_token);
              localStorage.setItem("wf_user",JSON.stringify(data.user));
              setUser(data.user);
            } else {
              localStorage.removeItem("wf_token");localStorage.removeItem("wf_user");localStorage.removeItem("wf_refresh");
            }
            setAuthChecked(true);
          }).catch(()=>{
            localStorage.removeItem("wf_token");localStorage.removeItem("wf_user");
            setAuthChecked(true);
          });
          return;
        } else if(expired){
          localStorage.removeItem("wf_token");localStorage.removeItem("wf_user");
        } else {
          setUser(JSON.parse(savedUser));
        }
      }catch(e){setUser(JSON.parse(savedUser));}
    }
    setAuthChecked(true);
  },[]);

  useEffect(()=>{if("Notification" in window)Notification.requestPermission();},[]);
  useEffect(()=>{
    if(!works.length)return;
    works.filter(w=>isOverdue(w.deadline,w.status)).forEach(w=>{
      const key=`notif_${w.id}_${w.deadline}`;
      if(!localStorage.getItem(key)&&"Notification" in window&&Notification.permission==="granted"){
        new Notification("⚠️ Workflow Overdue",{body:`"${w.title}" deadline crossed!`});
        localStorage.setItem(key,"1");
      }
    });
  },[works]);

  const loadProfile=useCallback(async()=>{
    if(!user)return;
    try{
      const res=await fetch(`${SB_URL}/rest/v1/profiles?id=eq.${user.id}`,{headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`}});
      const data=await res.json();
      if(data[0])setProfile(data[0]);
      else{
        await fetch(`${SB_URL}/rest/v1/profiles`,{method:"POST",headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":"application/json",Prefer:"return=representation"},body:JSON.stringify({id:user.id})});
      }
    }catch(e){}
  },[user]);

  useEffect(()=>{if(user)loadProfile();},[loadProfile,user]);

  const loadAll=useCallback(async()=>{
    if(!user)return;
    try{
      setLoading(true);
      const [cls,wks,revs,progs,tls]=await Promise.all([
        sb("clients?order=created_at.desc&select=*"),
        sb("works?order=created_at.desc&select=*"),
        sb("revisions?order=created_at.asc&select=*"),
        sb("progress?order=created_at.asc&select=*"),
        sb("timeline?order=created_at.asc&select=*"),
      ]);
      setClients(Array.isArray(cls)?cls:[]);
      setWorks(Array.isArray(wks)?wks.map(w=>({...w,tags:w.tags||[],revisions:(Array.isArray(revs)?revs:[]).filter(r=>r.work_id===w.id),progress:(Array.isArray(progs)?progs:[]).filter(p=>p.work_id===w.id),timeline:(Array.isArray(tls)?tls:[]).filter(t=>t.work_id===w.id)})):[]);
    }catch(e){
      console.error("Load error:",e);
      notify("Load error: "+e.message,"error");
    }finally{setLoading(false);}
  },[user]);
  useEffect(()=>{if(user)loadAll();},[loadAll,user]);

  const syncWork=u=>{setWorks(p=>p.map(w=>w.id===u.id?u:w));if(activeWork?.id===u.id)setActiveWork(u);};
  const addClient=async d=>{const[c]=await sb("clients","POST",{...d,user_id:user.id});setClients(p=>[c,...p]);notify("Client added! 👤");};
  const addWork=async d=>{
    const[w]=await sb("works","POST",{...d,budget:+d.budget||0,advance:+d.advance||0,user_id:user.id});
    await sb("timeline","POST",{work_id:w.id,event:"Project Created",user_id:user.id});
    setWorks(p=>[{...w,tags:w.tags||[],revisions:[],progress:[],timeline:[{event:"Project Created",created_at:new Date().toISOString()}]},...p]);
    notify("Work created! 🎯");
  };
  const advanceStatus=async w=>{
    const idx=STATUS_FLOW.indexOf(w.status);if(idx>=STATUS_FLOW.length-1)return;
    const next=STATUS_FLOW[idx+1];
    await sb(`works?id=eq.${w.id}`,"PATCH",{status:next});
    await sb("timeline","POST",{work_id:w.id,event:`Moved to ${next}`,user_id:user.id});
    syncWork({...w,status:next,timeline:[...w.timeline,{event:`Moved to ${next}`,created_at:new Date().toISOString()}]});
    notify(`→ ${next}`);
  };
  const bulkUpdateStatus=async newStatus=>{
    await Promise.all(selectedWorks.map(id=>sb(`works?id=eq.${id}`,"PATCH",{status:newStatus})));
    setWorks(p=>p.map(w=>selectedWorks.includes(w.id)?{...w,status:newStatus}:w));
    setSelectedWorks([]);setBulkMode(false);notify(`${selectedWorks.length} works → ${newStatus}`);
  };
  const addRevision=async(w,note)=>{
    const[rev]=await sb("revisions","POST",{work_id:w.id,note,user_id:user.id});
    const num=w.revisions.length+1;
    await sb("timeline","POST",{work_id:w.id,event:`Revision ${num} Added`,user_id:user.id});
    syncWork({...w,revisions:[...w.revisions,rev],timeline:[...w.timeline,{event:`Revision ${num} Added`,created_at:new Date().toISOString()}]});
    notify(`Revision ${num} added!`);
  };
  const addProgress=async(w,line)=>{const[p]=await sb("progress","POST",{work_id:w.id,line,user_id:user.id});syncWork({...w,progress:[...w.progress,p]});notify("Progress saved!");};
  const toggleDelivered=async w=>{
    const val=!w.delivered;await sb(`works?id=eq.${w.id}`,"PATCH",{delivered:val});
    let tl=w.timeline;
    if(val){await sb("timeline","POST",{work_id:w.id,event:"Delivered",user_id:user.id});tl=[...tl,{event:"Delivered",created_at:new Date().toISOString()}];}
    syncWork({...w,delivered:val,timeline:tl});notify(val?"✓ Delivered!":"Undone");
  };
  const setPayment=async(w,state)=>{
    const advance_received=state==="advance"||state==="full",paid=state==="full";
    await sb(`works?id=eq.${w.id}`,"PATCH",{advance_received,paid});
    let tl=w.timeline;
    if(state==="advance"&&!w.advance_received){await sb("timeline","POST",{work_id:w.id,event:"Advance Payment Received",user_id:user.id});tl=[...tl,{event:"Advance Payment Received",created_at:new Date().toISOString()}];}
    if(state==="full"&&!w.paid){await sb("timeline","POST",{work_id:w.id,event:"Full Payment Received",user_id:user.id});tl=[...tl,{event:"Full Payment Received",created_at:new Date().toISOString()}];}
    syncWork({...w,advance_received,paid,timeline:tl});notify(state==="full"?"💰 Full Payment!":state==="advance"?"Advance received!":"Reset");
  };
  const resolveOverdue=async(action)=>{
    const overdue=works.filter(w=>isOverdue(w.deadline,w.status));
    await Promise.all(overdue.map(async w=>{
      let patch={};
      if(action==="extend7"){
        const nd=new Date(w.deadline);nd.setDate(nd.getDate()+7);
        patch={deadline:nd.toISOString().split("T")[0]};
      } else if(action==="extend30"){
        const nd=new Date(w.deadline);nd.setDate(nd.getDate()+30);
        patch={deadline:nd.toISOString().split("T")[0]};
      } else if(action==="markSent"){
        patch={status:"Sent"};
        await sb("timeline","POST",{work_id:w.id,event:"Moved to Sent",user_id:user.id});
      } else if(action==="markCompleted"){
        patch={status:"Completed"};
        await sb("timeline","POST",{work_id:w.id,event:"Moved to Completed",user_id:user.id});
      }
      await sb(`works?id=eq.${w.id}`,"PATCH",patch);
      setWorks(p=>p.map(wk=>wk.id===w.id?{...wk,...patch}:wk));
    }));
    const msgs={extend7:"Deadlines extended by 7 days! 📅",extend30:"Deadlines extended by 30 days! 📅",markSent:"All marked as Sent! 📤",markCompleted:"All marked as Completed! ✅"};
    notify(msgs[action]);
  };

  const saveNotes=async(w,notes)=>{await sb(`works?id=eq.${w.id}`,"PATCH",{notes});syncWork({...w,notes});};
  const duplicateWork=async w=>{
    const{id,created_at,timeline,revisions,progress,...data}=w;
    await addWork({...data,title:`${w.title} (Copy)`,status:"Not Started",delivered:false,paid:false,advance_received:false});
    notify("Work duplicated! 📋");
  };

  const startTimer=workId=>{const now=Date.now();setTimeTrackers(p=>{const t=p[workId]||{total:0};return{...p,[workId]:{...t,running:true,start:now}};});};
  const stopTimer=workId=>{setTimeTrackers(p=>{const t=p[workId];if(!t||!t.running)return p;return{...p,[workId]:{total:(t.total||0)+Date.now()-t.start,running:false,start:null}};});};
  const getTimerDisplay=workId=>{const t=timeTrackers[workId];if(!t)return"0h 0m";const total=(t.total||0)+(t.running?Date.now()-t.start:0);const h=Math.floor(total/3600000),m=Math.floor((total%3600000)/60000);return`${h}h ${m}m`;};

  // Dynamic accent
  const AC = accentColor || "#6C63FF";

  // Update WA templates with dynamic ones
  const getWAMessage = (work, type) => {
    const cl = clients.find(c=>c.id===work.client_id);
    const tpl = waTemplates[type==="revision"?"Revision":work.status] || `Hi, update on *${work.title}*`;
    return tpl.replace("{client}", cl?.name||"Client").replace("{work}", work.title);
  };

  const sendWhatsApp=(work,type="status")=>{
    const cl=clients.find(c=>c.id===work.client_id);
    const msg=getWAMessage(work,type);
    const phone=(cl?.phone||"").replace(/\D/g,"");
    window.open(`https://wa.me/${phone.startsWith("91")?phone:"91"+phone}?text=${encodeURIComponent(msg)}`,"_blank");
  };

  const addPinnedNote=text=>{if(!text.trim())return;setPinnedNotes(p=>[{id:Date.now(),text,created_at:new Date().toISOString()},...p]);notify("Note pinned! 📌");};
  const removePinnedNote=id=>setPinnedNotes(p=>p.filter(n=>n.id!==id));

  const sortAndFilter=worklist=>{
    let f=worklist;
    if(filterStatus!=="All")f=f.filter(w=>w.status===filterStatus);
    if(filterPriority!=="All")f=f.filter(w=>w.priority===filterPriority);
    if(searchQ.length>1)f=f.filter(w=>`${w.title} ${w.category} ${w.status} ${w.tags?.join(" ")||""}`.toLowerCase().includes(searchQ.toLowerCase()));
    return f.sort((a,b)=>{
      if(sortBy==="Newest")return new Date(b.created_at)-new Date(a.created_at);
      if(sortBy==="Oldest")return new Date(a.created_at)-new Date(b.created_at);
      if(sortBy==="Deadline")return new Date(a.deadline||"9999")-new Date(b.deadline||"9999");
      if(sortBy==="Priority")return PRIORITIES.indexOf(b.priority)-PRIORITIES.indexOf(a.priority);
      if(sortBy==="Amount")return(b.budget||0)-(a.budget||0);
      if(sortBy==="Status")return STATUS_FLOW.indexOf(a.status)-STATUS_FLOW.indexOf(b.status);
      return 0;
    });
  };

  const getMonthlyStats=m=>{
    const year=new Date().getFullYear();
    const start=new Date(year,m,1,0,0,0);
    const end=new Date(year,m+1,0,23,59,59);
    // If "All" selected show all works
    const mw = m===-1 ? works : works.filter(w=>{
      if(!w.created_at) return false;
      const d=new Date(w.created_at);
      return d>=start && d<=end;
    });
    return{
      total:mw.length,
      completed:mw.filter(w=>w.status==="Completed").length,
      revenue:mw.reduce((a,w)=>a+(w.budget||0),0),
      received:mw.reduce((a,w)=>a+(w.paid?(w.budget||0):w.advance_received?(w.advance||0):0),0),
      revisions:mw.reduce((a,w)=>a+(w.revisions?.length||0),0),
      clients:[...new Set(mw.map(w=>w.client_id))].filter(Boolean).length,
    };
  };

  const getBestWorkType=()=>{
    const cats={};
    works.forEach(w=>{if(w.category){if(!cats[w.category])cats[w.category]={count:0,revenue:0};cats[w.category].count++;cats[w.category].revenue+=(w.budget||0);}});
    return Object.entries(cats).sort((a,b)=>b[1].revenue-a[1].revenue).slice(0,6);
  };

  const getClientHealth=cid=>{
    const cw=works.filter(w=>w.client_id===cid);if(!cw.length)return"new";
    const paidR=cw.filter(w=>w.paid).length/cw.length;
    const revAvg=cw.reduce((a,w)=>a+w.revisions.length,0)/cw.length;
    const overdue=cw.filter(w=>isOverdue(w.deadline,w.status)).length;
    if(paidR>0.7&&revAvg<2&&overdue===0)return"vip";
    if(paidR<0.3||overdue>0||revAvg>4)return"problem";
    return"normal";
  };

  const todayWorks=works.filter(w=>{
    if(!w.created_at) return false;
    return new Date(w.created_at).toDateString()===todayStr();
  });
  const pendingWorks=works.filter(w=>w.status!=="Completed");
  const completedWorks=works.filter(w=>w.status==="Completed");
  const overdueWorks=works.filter(w=>isOverdue(w.deadline,w.status));
  const todayRevisions=works.filter(w=>(w.revisions||[]).some(r=>new Date(r.created_at).toDateString()===todayStr()));
  const unpaidWorks=works.filter(w=>!w.paid);
  const clientWorks=cid=>works.filter(w=>w.client_id===cid);
  const totalBudget=works.reduce((a,w)=>a+(w.budget||0),0);
  const totalReceived=works.reduce((a,w)=>a+(w.paid?(w.budget||0):w.advance_received?(w.advance||0):0),0);

  const openClient=c=>{setActiveClient(c);setView("client-detail");};
  const openWork=w=>{setActiveWork(w);setView("work-detail");};
  const goBack=()=>{if(view==="work-detail"){setView("client-detail");setActiveWork(null);}else{setView("clients");setActiveClient(null);}};
  const navTo=v=>{setView(v);setSearchQ("");setShowSearch(false);setBulkMode(false);setSelectedWorks([]);};
  const logout=()=>{localStorage.removeItem("wf_token");localStorage.removeItem("wf_user");localStorage.removeItem("wf_refresh");setUser(null);setClients([]);setWorks([]);};

  if(!authChecked)return<Loader/>;
  if(!user)return<LoginScreen onLogin={u=>setUser(u)}/>;
  if(loading)return<Loader/>;

  const monthStats=getMonthlyStats(analyticsMonth);
  const bestTypes=getBestWorkType();
  const isClientOrWork=view==="client-detail"||view==="work-detail";
  const hConfig={vip:{color:C.success,bg:"rgba(34,197,94,0.1)",label:"VIP"},normal:{color:C.warning,bg:"rgba(245,158,11,0.1)",label:"Active"},problem:{color:C.danger,bg:"rgba(239,68,68,0.1)",label:"Attention"},new:{color:T.muted,bg:T.card,label:"New"}};

  return (
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"'Inter','Segoe UI',system-ui,sans-serif",color:T.text,paddingBottom:bp.isMobile?70:0}}>
      <style>{`*{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}input,textarea,select{-webkit-appearance:none;}button{cursor:pointer;font-family:inherit;}::-webkit-scrollbar{width:3px;}::-webkit-scrollbar-thumb{background:${T.border};border-radius:4px;}@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.3}}@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      {toast&&<Toast msg={toast.msg} type={toast.type}/>}

      <header style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:bp.isMobile?"12px 16px":"14px 24px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          {isClientOrWork&&<button onClick={goBack} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:8,padding:"5px 12px",fontSize:13,fontWeight:600}}>← Back</button>}
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <Logo size={30}/>
            <span style={{fontWeight:800,fontSize:bp.isMobile?15:17,color:T.text,letterSpacing:"-0.3px"}}>{businessProfile.name||"Workflow"}</span>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          {!bp.isMobile&&<div style={{position:"relative"}}><span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:T.muted,fontSize:13}}>🔍</span><input value={searchQ} onChange={e=>setSearchQ(e.target.value)} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"8px 12px 8px 32px",fontSize:13,outline:"none",width:220}} placeholder="Search…"/></div>}
          {bp.isMobile&&<button onClick={()=>setShowSearch(s=>!s)} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 10px",fontSize:15}}>🔍</button>}
          <button onClick={()=>setDark(d=>!d)} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 10px",fontSize:15}}>{dark?"☀️":"🌙"}</button>
          <div style={{position:"relative"}}>
            <button onClick={()=>setModal(modal==="user-menu"?null:"user-menu")} style={{width:34,height:34,borderRadius:"50%",background:C.accent,border:"none",overflow:"hidden",padding:0,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
              {profile?.avatar_url
                ?<img src={profile.avatar_url} alt="avatar" style={{width:34,height:34,objectFit:"cover",borderRadius:"50%"}}/>
                :<span style={{color:"#fff",fontWeight:800,fontSize:13}}>{profile?.full_name?.[0]?.toUpperCase()||user?.email?.[0]?.toUpperCase()||"W"}</span>
              }
            </button>
            {modal==="user-menu"&&<div style={{position:"absolute",right:0,top:40,background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:8,minWidth:210,zIndex:200,boxShadow:"0 8px 24px #0006"}}>
              <div style={{padding:"8px 12px",color:T.muted,fontSize:12,borderBottom:`1px solid ${T.border}`,marginBottom:4}}>{profile?.full_name&&<div style={{color:T.text,fontWeight:700,fontSize:13,marginBottom:2}}>{profile.full_name}</div>}{user?.email}</div>
              <button onClick={()=>{setModal(null);navTo("profile");}} style={{width:"100%",background:"none",border:"none",color:T.text,padding:"9px 12px",fontSize:13,textAlign:"left",borderRadius:8}}>👤 My Profile</button>
              <button onClick={()=>{setModal(null);navTo("settings");}} style={{width:"100%",background:"none",border:"none",color:T.text,padding:"9px 12px",fontSize:13,textAlign:"left",borderRadius:8}}>⚙️ Settings</button>
              <button onClick={()=>{setModal(null);navTo("analytics");}} style={{width:"100%",background:"none",border:"none",color:T.text,padding:"9px 12px",fontSize:13,textAlign:"left",borderRadius:8}}>📈 Analytics</button>
              <button onClick={()=>{setModal(null);logout();}} style={{width:"100%",background:"none",border:"none",color:C.danger,padding:"9px 12px",fontSize:13,textAlign:"left",borderRadius:8}}>🚪 Sign Out</button>
            </div>}
          </div>
        </div>
      </header>

      {bp.isMobile&&showSearch&&<div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"10px 14px"}}><input value={searchQ} onChange={e=>setSearchQ(e.target.value)} autoFocus style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 14px",fontSize:14,outline:"none",width:"100%"}} placeholder="Search…"/></div>}

      {!bp.isMobile&&<nav style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"0 24px",display:"flex",gap:4}}>
        {[["dashboard","📊 Dashboard"],["clients","👥 Clients"],["calendar","📅 Calendar"],["analytics","📈 Analytics"],["profile","👤 Profile"],["settings","⚙️ Settings"]].map(([k,l])=>(
          <button key={k} onClick={()=>navTo(k)} style={{background:"none",border:"none",color:(view===k||view==="client-detail"&&k==="clients"||view==="work-detail"&&k==="clients")?AC:T.muted,padding:"13px 18px",fontSize:14,fontWeight:700,borderBottom:`3px solid ${(view===k||view==="client-detail"&&k==="clients"||view==="work-detail"&&k==="clients")?AC:"transparent"}`,transition:"all 0.15s"}}>{l}</button>
        ))}
      </nav>}

      <main style={{padding:bp.isMobile?"14px":"24px 24px",maxWidth:"100%"}}>

        {/* DASHBOARD */}
        {view==="dashboard"&&<DashboardView T={T} bp={bp} works={works} clients={clients} overdueWorks={overdueWorks} todayWorks={todayWorks} pendingWorks={pendingWorks} completedWorks={completedWorks} todayRevisions={todayRevisions} unpaidWorks={unpaidWorks} totalBudget={totalBudget} totalReceived={totalReceived} pinnedNotes={pinnedNotes} onRemoveNote={removePinnedNote} onAddNote={addPinnedNote} onOpenWork={openWork} onNavClients={()=>navTo("clients")} onResolveOverdue={resolveOverdue}/>}

        {/* CLIENTS */}
        {view==="clients"&&<ClientsView T={T} bp={bp} clients={clients} works={works} searchQ={searchQ} setSearchQ={setSearchQ} getClientHealth={getClientHealth} hConfig={hConfig} clientWorks={clientWorks} onOpenClient={openClient} onAddClient={()=>setModal("add-client")}/>}

        {/* CLIENT DETAIL */}
        {view==="client-detail"&&activeClient&&<ClientDetailView T={T} bp={bp} client={activeClient} works={sortAndFilter(clientWorks(activeClient.id))} allWorks={clientWorks(activeClient.id)} bulkMode={bulkMode} selectedWorks={selectedWorks} sortBy={sortBy} filterStatus={filterStatus} filterPriority={filterPriority} timeTrackers={timeTrackers} getTimerDisplay={getTimerDisplay} onSortBy={setSortBy} onFilterStatus={setFilterStatus} onFilterPriority={setFilterPriority} onBulkToggle={()=>{setBulkMode(b=>!b);setSelectedWorks([]);}} onSelectWork={id=>setSelectedWorks(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id])} onBulkUpdate={bulkUpdateStatus} onOpenWork={openWork} onAddWork={()=>setModal("add-work")} onReport={()=>setModal("report")} onWhatsApp={ph=>window.open(`https://wa.me/91${ph.replace(/\D/g,"")}?text=${encodeURIComponent(`Hi ${activeClient.name}!`)}`,"_blank")}/>}

        {/* WORK DETAIL */}
        {view==="work-detail"&&activeWork&&<WorkDetail work={activeWork} T={T} bp={bp} clients={clients} businessProfile={businessProfile} timer={timeTrackers[activeWork.id]} timerDisplay={getTimerDisplay(activeWork.id)} onAdvance={()=>advanceStatus(activeWork)} onRevision={note=>addRevision(activeWork,note)} onProgress={line=>addProgress(activeWork,line)} onDelivery={()=>toggleDelivered(activeWork)} onPayment={state=>setPayment(activeWork,state)} onNoteChange={notes=>saveNotes(activeWork,notes)} onWhatsApp={type=>sendWhatsApp(activeWork,type)} onDuplicate={()=>duplicateWork(activeWork)} onStartTimer={()=>startTimer(activeWork.id)} onStopTimer={()=>stopTimer(activeWork.id)} invoiceDefaults={invoiceDefaults}/>}

        {/* CALENDAR */}
        {view==="calendar"&&<CalendarView T={T} bp={bp} works={works} clients={clients} onOpenWork={openWork} accentColor={AC}/>}

        {/* ANALYTICS */}
        {view==="analytics"&&<AnalyticsView T={T} bp={bp} monthStats={monthStats} bestTypes={bestTypes} clients={clients} works={works} analyticsMonth={analyticsMonth} setAnalyticsMonth={setAnalyticsMonth} getClientHealth={getClientHealth} clientWorks={clientWorks}/>}

        {/* PROFILE */}
        {view==="profile"&&<ProfileView T={T} bp={bp} user={user} profile={profile} setProfile={setProfile} notify={notify} clients={clients} works={works}/>}

        {/* SETTINGS */}
        {view==="settings"&&<SettingsView T={T} bp={bp} user={user} businessProfile={businessProfile} setBusinessProfile={setBusinessProfile} customCategories={customCategories} setCustomCategories={setCustomCategories} DEFAULT_CATEGORIES={DEFAULT_CATEGORIES} clients={clients} works={works} notify={notify} onLogout={logout} accentColor={AC} setAccentColor={setAccentColor} currency={currency} setCurrency={setCurrency} dateFormat={dateFormat} setDateFormat={setDateFormat} notifPrefs={notifPrefs} setNotifPrefs={setNotifPrefs} invoiceDefaults={invoiceDefaults} setInvoiceDefaults={setInvoiceDefaults} defaultView={defaultView} setDefaultView={setDefaultView} waTemplates={waTemplates} setWaTemplates={setWaTemplates} workTemplates={workTemplates} setWorkTemplates={setWorkTemplates}/>}
      </main>

      {bp.isMobile&&<nav style={{position:"fixed",bottom:0,left:0,right:0,background:T.surface,borderTop:`1px solid ${T.border}`,display:"flex",padding:"8px 0 12px",zIndex:100}}>
        {[["dashboard","📊","Home"],["clients","👥","Clients"],["calendar","📅","Calendar"],["analytics","📈","Stats"],["profile","👤","Profile"],["settings","⚙️","Settings"]].map(([k,icon,label])=>(
          <button key={k} onClick={()=>navTo(k)} style={{flex:1,background:"none",border:"none",color:(view===k||view==="client-detail"&&k==="clients"||view==="work-detail"&&k==="clients")?C.accent:T.muted,display:"flex",flexDirection:"column",alignItems:"center",gap:3,padding:"4px 0"}}>
            <span style={{fontSize:18}}>{icon}</span><span style={{fontSize:9,fontWeight:700}}>{label}</span>
          </button>
        ))}
      </nav>}

      {showInstallBanner&&<div style={{position:"fixed",bottom:bp.isMobile?80:24,left:bp.isMobile?12:24,right:bp.isMobile?12:"auto",background:T.surface,border:`1px solid ${C.accent}`,borderRadius:16,padding:"14px 18px",zIndex:150,boxShadow:"0 8px 32px rgba(108,99,255,0.3)",display:"flex",alignItems:"center",gap:14,maxWidth:360}}>
        <div style={{flexShrink:0}}><Logo size={44}/></div>
        <div style={{flex:1,minWidth:0}}><div style={{color:T.text,fontWeight:700,fontSize:14}}>Install Workflow</div><div style={{color:T.muted,fontSize:12}}>workflow.loytro.com</div></div>
        <div style={{display:"flex",gap:8,flexShrink:0}}>
          <button onClick={()=>setShowInstallBanner(false)} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:8,padding:"7px 12px",fontWeight:600,fontSize:12}}>Cancel</button>
          <button onClick={async()=>{if(installPrompt){installPrompt.prompt();const{outcome}=await installPrompt.userChoice;if(outcome==="accepted")notify("App installed! 🎉");}setShowInstallBanner(false);}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 16px",fontWeight:700,fontSize:12}}>Install</button>
        </div>
      </div>}

      <button onClick={()=>setShowQuickAdd(true)} style={{position:"fixed",bottom:bp.isMobile?80:24,right:20,width:52,height:52,borderRadius:"50%",background:C.accent,color:"#fff",border:"none",fontSize:26,fontWeight:700,boxShadow:"0 4px 20px rgba(108,99,255,0.5)",zIndex:90,display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>

      {/* ONBOARDING */}
      {showOnboarding&&user&&clients.length===0&&<OnboardingFlow T={T} bp={bp} user={user} accentColor={AC} onComplete={()=>{lsSet("wf_onboarded",true);setShowOnboarding(false);}} onAddClient={async d=>{await addClient(d);}} onAddWork={async d=>{await addWork(d);}}/>}

      {modal==="add-client"&&<AddClientModal T={T} bp={bp} onSave={async d=>{await addClient(d);setModal(null);}} onClose={()=>setModal(null)}/>}
      {modal==="add-work"&&activeClient&&<AddWorkModal T={T} bp={bp} clientId={activeClient.id} categories={customCategories} onSave={async d=>{await addWork(d);setModal(null);}} onClose={()=>setModal(null)}/>}
      {modal==="report"&&activeClient&&<ReportModal T={T} bp={bp} client={activeClient} works={clientWorks(activeClient.id)} businessProfile={businessProfile} onClose={()=>setModal(null)}/>}
      {modal==="user-menu"&&<div style={{position:"fixed",inset:0,zIndex:150}} onClick={()=>setModal(null)}/>}
      {showQuickAdd&&<QuickAdd T={T} bp={bp} clients={clients} categories={customCategories} onSave={async d=>{await addWork(d);setShowQuickAdd(false);notify("Quick work added! 🚀");}} onClose={()=>setShowQuickAdd(false)}/>}
    </div>
  );
}

// ── Dashboard View ────────────────────────────────────────────────────────────
function DashboardView({T,bp,works,clients,overdueWorks,todayWorks,pendingWorks,completedWorks,todayRevisions,unpaidWorks,totalBudget,totalReceived,pinnedNotes,onRemoveNote,onAddNote,onOpenWork,onNavClients,onResolveOverdue}){
  const [showResolveModal,setShowResolveModal]=useState(false);

  return(
    <div>
      {/* Overdue Alert */}
      {overdueWorks.length>0&&(
        <div style={{background:"rgba(239,68,68,0.12)",border:"1px solid rgba(239,68,68,0.3)",borderRadius:12,padding:"12px 16px",marginBottom:14}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
            <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
              <span style={{fontSize:20,flexShrink:0}}>🚨</span>
              <div>
                <div style={{color:C.danger,fontWeight:700,fontSize:13,marginBottom:4}}>{overdueWorks.length} Overdue Work{overdueWorks.length>1?"s":""}</div>
                {overdueWorks.map(w=>{
                  const cl=clients.find(c=>c.id===w.client_id);
                  const daysOver=Math.floor((Date.now()-new Date(w.deadline))/86400000);
                  return(
                    <div key={w.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                      <span style={{color:"#F0F0F8",fontSize:12,fontWeight:600}}>{w.title}</span>
                      <span style={{color:T.muted,fontSize:11}}>· {cl?.name}</span>
                      <span style={{background:C.danger+"33",color:C.danger,borderRadius:20,padding:"1px 8px",fontSize:10,fontWeight:700}}>{daysOver}d overdue</span>
                      <button onClick={()=>onOpenWork(w)} style={{background:"none",border:`1px solid ${C.danger}44`,color:C.danger,borderRadius:6,padding:"1px 8px",fontSize:10,cursor:"pointer",fontWeight:600}}>View →</button>
                    </div>
                  );
                })}
              </div>
            </div>
            <button onClick={()=>setShowResolveModal(true)} style={{background:C.danger,color:"#fff",border:"none",borderRadius:8,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>RESOLVE ALL</button>
          </div>
        </div>
      )}

      {/* Resolve Modal */}
      {showResolveModal&&(
        <div style={{position:"fixed",inset:0,background:"#00000090",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16,backdropFilter:"blur(4px)"}}>
          <div style={{background:T.surface,borderRadius:16,padding:24,width:"100%",maxWidth:420,border:`1px solid ${T.border}`}}>
            <div style={{color:T.text,fontWeight:800,fontSize:16,marginBottom:6}}>🚨 Resolve Overdue Works</div>
            <div style={{color:T.muted,fontSize:13,marginBottom:16}}>Choose action for {overdueWorks.length} overdue work{overdueWorks.length>1?"s":""}:</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button onClick={()=>{onResolveOverdue("extend7");setShowResolveModal(false);}} style={{background:C.warning+"22",color:C.warning,border:`1px solid ${C.warning}44`,borderRadius:10,padding:"12px 16px",fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left"}}>
                📅 Extend deadline by 7 days
                <div style={{color:T.muted,fontSize:11,fontWeight:400,marginTop:3}}>All overdue works deadline will move ahead 7 days</div>
              </button>
              <button onClick={()=>{onResolveOverdue("extend30");setShowResolveModal(false);}} style={{background:T.card,color:T.text,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 16px",fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left"}}>
                📅 Extend deadline by 30 days
                <div style={{color:T.muted,fontSize:11,fontWeight:400,marginTop:3}}>Move all deadlines 1 month ahead</div>
              </button>
              <button onClick={()=>{onResolveOverdue("markSent");setShowResolveModal(false);}} style={{background:C.purple+"22",color:C.purple,border:`1px solid ${C.purple}44`,borderRadius:10,padding:"12px 16px",fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left"}}>
                📤 Mark all as "Sent"
                <div style={{color:T.muted,fontSize:11,fontWeight:400,marginTop:3}}>Change status to Sent — removes overdue flag</div>
              </button>
              <button onClick={()=>{onResolveOverdue("markCompleted");setShowResolveModal(false);}} style={{background:C.success+"22",color:C.success,border:`1px solid ${C.success}44`,borderRadius:10,padding:"12px 16px",fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"left"}}>
                ✅ Mark all as "Completed"
                <div style={{color:T.muted,fontSize:11,fontWeight:400,marginTop:3}}>Close all overdue works as completed</div>
              </button>
            </div>
            <button onClick={()=>setShowResolveModal(false)} style={{width:"100%",background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:10,padding:"10px",fontWeight:600,fontSize:13,marginTop:12,cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      )}
      {pinnedNotes.length>0&&<div style={{background:T.surface,borderRadius:14,padding:"14px 18px",border:`2px solid ${C.warning}44`,marginBottom:14}}><div style={{fontWeight:700,fontSize:13,color:C.warning,marginBottom:10}}>📌 Pinned Notes</div>{pinnedNotes.map(n=><div key={n.id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"6px 0",borderBottom:`1px solid ${T.border}`,gap:8}}><div style={{color:T.text,fontSize:13}}>{n.text}</div><button onClick={()=>onRemoveNote(n.id)} style={{background:"none",border:"none",color:T.muted,fontSize:14,flexShrink:0,padding:"0 4px"}}>✕</button></div>)}</div>}
      <div style={{display:"grid",gridTemplateColumns:bp.isMobile?"repeat(2,1fr)":"repeat(6,1fr)",gap:10,marginBottom:14}}>
        {[{label:"TODAY'S WORK",value:todayWorks.length,sub:`${works.filter(w=>w.priority==="High").length} high priority`,color:C.accent},{label:"PENDING",value:pendingWorks.length,sub:"Awaiting client",color:C.warning},{label:"COMPLETED",value:completedWorks.length,sub:"All time",color:C.success},{label:"REVISIONS",value:todayRevisions.length,sub:"Today",color:C.purple},{label:"PAYMENTS",value:unpaidWorks.length,sub:"Not paid",color:"#38BDF8"},{label:"OVERDUE",value:overdueWorks.length,sub:overdueWorks.length>0?"Critical":"All good",color:C.danger}].map(({label,value,sub,color})=>(
          <div key={label} style={{background:T.surface,borderRadius:12,padding:bp.isMobile?"12px 10px":"14px",border:`1px solid ${T.border}`,position:"relative",overflow:"hidden"}}>
            <div style={{color:T.muted,fontSize:9,fontWeight:700,letterSpacing:"0.08em",marginBottom:6}}>{label}</div>
            <div style={{color,fontSize:bp.isMobile?24:28,fontWeight:900,lineHeight:1,marginBottom:3}}>{value}</div>
            <div style={{color:T.muted,fontSize:9}}>{sub}</div>
            <div style={{position:"absolute",bottom:0,left:0,right:0,height:2,background:color}}/>
          </div>
        ))}
      </div>
      <div style={{background:T.surface,borderRadius:14,padding:"16px 18px",border:`1px solid ${T.border}`,marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}><div><div style={{fontWeight:700,fontSize:14}}>Revenue</div><div style={{color:T.muted,fontSize:12}}>{new Date().toLocaleDateString("en-IN",{month:"long",year:"numeric"})}</div></div><div style={{color:C.accent,fontWeight:900,fontSize:20}}>₹{totalBudget.toLocaleString()}</div></div>
        <div style={{background:T.card,borderRadius:4,height:8,marginBottom:12,overflow:"hidden"}}><div style={{background:`linear-gradient(90deg,${C.accent},${C.success})`,height:"100%",width:`${totalBudget>0?Math.min(100,totalReceived/totalBudget*100):0}%`,borderRadius:4,transition:"width 0.5s"}}/></div>
        <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}><div style={{width:8,height:8,borderRadius:"50%",background:C.accent}}/><span style={{color:T.muted,fontSize:12}}>Received</span><span style={{color:T.text,fontWeight:700,fontSize:13,marginLeft:4}}>₹{totalReceived.toLocaleString()}</span></div>
          <div style={{display:"flex",alignItems:"center",gap:6}}><div style={{width:8,height:8,borderRadius:"50%",background:C.warning}}/><span style={{color:T.muted,fontSize:12}}>Pending</span><span style={{color:T.text,fontWeight:700,fontSize:13,marginLeft:4}}>₹{(totalBudget-totalReceived).toLocaleString()}</span></div>
        </div>
      </div>
      <PinnedNoteInput T={T} onAdd={onAddNote}/>
      {todayWorks.length>0&&<div style={{background:T.surface,borderRadius:14,padding:"16px 18px",border:`1px solid ${T.border}`,marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}><div style={{fontWeight:700,fontSize:14}}>Today's Work</div><button onClick={onNavClients} style={{background:"none",border:"none",color:C.accent,fontSize:12,fontWeight:700}}>VIEW ALL</button></div>
        {todayWorks.slice(0,5).map(w=>{const cl=clients.find(c=>c.id===w.client_id);return(
          <div key={w.id} onClick={()=>onOpenWork(w)} style={{display:"flex",alignItems:"center",gap:12,padding:"9px 0",borderBottom:`1px solid ${T.border}`,cursor:"pointer"}}>
            <div style={{width:16,height:16,borderRadius:4,border:`2px solid ${w.status==="Completed"?C.success:T.border}`,background:w.status==="Completed"?C.success:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{w.status==="Completed"&&<span style={{color:"#fff",fontSize:9}}>✓</span>}</div>
            <div style={{flex:1,minWidth:0}}><div style={{color:T.text,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title}</div><div style={{color:T.muted,fontSize:11}}>{cl?.name}</div></div>
            <SBadge status={w.status}/>
          </div>
        );})}
      </div>}
      <div style={{display:"grid",gridTemplateColumns:bp.isMobile?"1fr":"1fr 1fr",gap:14}}>
        <div style={{background:T.surface,borderRadius:14,padding:"16px 18px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:14}}>Recent Activity</div>
          {works.length===0&&<Empty icon="⚡" msg="No activity yet"/>}
          {works.slice(0,6).flatMap(w=>w.timeline.slice(-1).map((t,i)=>{const cl=clients.find(c=>c.id===w.client_id);return(<div key={w.id+i} style={{display:"flex",gap:10,padding:"9px 0",borderBottom:`1px solid ${T.border}`,alignItems:"flex-start"}}><Av name={cl?.name||"W"} size={28}/><div style={{flex:1,minWidth:0}}><div style={{color:T.text,fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title} — {t.event}</div><div style={{color:T.muted,fontSize:11}}>{fmt(t.created_at)}</div></div></div>);})).slice(0,6)}
        </div>
        <div style={{background:T.surface,borderRadius:14,padding:"16px 18px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:14}}>Pending Payments</div>
          {unpaidWorks.length===0&&<Empty icon="🎉" msg="All cleared!"/>}
          {unpaidWorks.slice(0,5).map(w=>{const cl=clients.find(c=>c.id===w.client_id);return(<div key={w.id} onClick={()=>onOpenWork(w)} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"9px 0",borderBottom:`1px solid ${T.border}`,cursor:"pointer",gap:8}}><div style={{minWidth:0}}><div style={{color:T.text,fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title}</div><div style={{color:T.muted,fontSize:11}}>{cl?.name}</div></div><div style={{color:C.danger,fontWeight:800,fontSize:13,flexShrink:0}}>₹{((w.budget||0)-(w.advance||0)).toLocaleString()}</div></div>);})}
        </div>
      </div>
    </div>
  );
}

// ── Clients View ──────────────────────────────────────────────────────────────
function ClientsView({T,bp,clients,works,searchQ,setSearchQ,getClientHealth,hConfig,clientWorks,onOpenClient,onAddClient}){
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
        <div><h2 style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,margin:0}}>Clients</h2><div style={{color:T.muted,fontSize:12,marginTop:2}}>{clients.length} total</div></div>
        <button onClick={onAddClient} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"9px 18px",fontWeight:700,fontSize:13}}>+ New Client</button>
      </div>
      <div style={{position:"relative",marginBottom:14}}><span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.muted}}>🔍</span><input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Search clients…" style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"9px 14px 9px 36px",fontSize:13,outline:"none",width:"100%"}}/></div>
      {clients.filter(c=>`${c.name} ${c.company||""}`.toLowerCase().includes(searchQ.toLowerCase())).map(c=>{
        const cw=clientWorks(c.id);const h=hConfig[getClientHealth(c.id)];
        return(<div key={c.id} onClick={()=>onOpenClient(c)} style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"12px 14px":"14px 18px",marginBottom:10,cursor:"pointer",display:"flex",alignItems:"center",gap:14,border:`1px solid ${T.border}`}}>
          <Av name={c.name} size={bp.isMobile?40:46}/>
          <div style={{flex:1,minWidth:0}}><div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}><div style={{color:T.text,fontWeight:700,fontSize:bp.isMobile?14:15,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.name}</div><div style={{background:h.bg,color:h.color,borderRadius:20,padding:"1px 8px",fontSize:10,fontWeight:700,flexShrink:0}}>{h.label}</div></div>
          {c.company&&<div style={{color:T.muted,fontSize:12}}>{c.company}</div>}{c.phone&&<div style={{color:T.muted,fontSize:12}}>📱 {c.phone}</div>}</div>
          <div style={{textAlign:"right",flexShrink:0}}><div style={{color:C.accent,fontWeight:800,fontSize:16}}>{cw.length}</div><div style={{color:T.muted,fontSize:11}}>works</div>{cw.filter(w=>!w.paid).length>0&&<div style={{color:C.danger,fontSize:11,fontWeight:700}}>₹{cw.filter(w=>!w.paid).reduce((a,w)=>a+((w.budget||0)-(w.advance||0)),0).toLocaleString()} due</div>}</div>
        </div>);
      })}
      {clients.length===0&&<Empty icon="👥" msg="Add your first client to get started!" btnLabel="+ Add Client" onBtnClick={onAddClient}/>}
    </div>
  );
}

// ── Client Detail View ────────────────────────────────────────────────────────
function ClientDetailView({T,bp,client,works,allWorks,bulkMode,selectedWorks,sortBy,filterStatus,filterPriority,timeTrackers,getTimerDisplay,onSortBy,onFilterStatus,onFilterPriority,onBulkToggle,onSelectWork,onBulkUpdate,onOpenWork,onAddWork,onReport,onWhatsApp}){
  return(
    <div>
      <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"14px":"18px",marginBottom:16,border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",gap:14,alignItems:"center"}}><Av name={client.name} size={bp.isMobile?44:52}/><div><div style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?16:19}}>{client.name}</div>{client.company&&<div style={{background:C.accent+"22",color:C.accent,borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:600,display:"inline-block",marginTop:4}}>{client.company}</div>}</div></div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {client.phone&&<button onClick={()=>onWhatsApp(client.phone)} style={{background:"#25D366",color:"#fff",border:"none",borderRadius:10,padding:"8px 14px",fontWeight:700,fontSize:12}}>📤 WA</button>}
            <button onClick={onReport} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"8px 14px",fontWeight:700,fontSize:12}}>📄 Report</button>
          </div>
        </div>
        {client.phone&&<div style={{color:T.muted,fontSize:13,marginBottom:3}}>📱 {client.phone}</div>}
        {client.email&&<div style={{color:T.muted,fontSize:13,marginBottom:3}}>✉️ {client.email}</div>}
        {client.notes&&<div style={{color:C.warning,fontSize:13,marginTop:8,background:C.warning+"11",borderRadius:8,padding:"8px 12px"}}>📝 {client.notes}</div>}
      </div>
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
        <select value={filterStatus} onChange={e=>onFilterStatus(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
          <option value="All">All Status</option>{STATUS_FLOW.map(s=><option key={s}>{s}</option>)}
        </select>
        <select value={filterPriority} onChange={e=>onFilterPriority(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
          <option value="All">All Priority</option>{PRIORITIES.map(p=><option key={p}>{p}</option>)}
        </select>
        <select value={sortBy} onChange={e=>onSortBy(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
          {SORT_OPTIONS.map(s=><option key={s}>{s}</option>)}
        </select>
        <button onClick={onBulkToggle} style={{background:bulkMode?C.accent:T.surface,color:bulkMode?"#fff":T.muted,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",fontSize:12,fontWeight:700}}>{bulkMode?"✕ Cancel":"Bulk"}</button>
        <button onClick={onAddWork} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"8px 16px",fontWeight:700,fontSize:12,marginLeft:"auto"}}>+ Add Work</button>
      </div>
      {bulkMode&&selectedWorks.length>0&&<div style={{background:C.accent+"22",border:`1px solid ${C.accent}44`,borderRadius:12,padding:"10px 14px",marginBottom:12,display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
        <span style={{color:C.accent,fontWeight:700,fontSize:13}}>{selectedWorks.length} selected → Move to:</span>
        {STATUS_FLOW.map(s=><button key={s} onClick={()=>onBulkUpdate(s)} style={{background:STATUS_COLOR[s]+"22",color:STATUS_COLOR[s],border:`1px solid ${STATUS_COLOR[s]}44`,borderRadius:20,padding:"4px 12px",fontSize:11,fontWeight:700}}>{s}</button>)}
      </div>}
      {works.map(w=>(
        <div key={w.id} style={{background:T.surface,borderRadius:12,padding:bp.isMobile?"12px":"14px 18px",marginBottom:10,border:`1px solid ${bulkMode&&selectedWorks.includes(w.id)?C.accent:T.border}`,transition:"border-color 0.15s"}}>
          <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
            {bulkMode&&<div onClick={()=>onSelectWork(w.id)} style={{width:20,height:20,borderRadius:6,border:`2px solid ${selectedWorks.includes(w.id)?C.accent:T.border}`,background:selectedWorks.includes(w.id)?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:2,cursor:"pointer"}}>{selectedWorks.includes(w.id)&&<span style={{color:"#fff",fontSize:11}}>✓</span>}</div>}
            <div style={{flex:1,cursor:"pointer"}} onClick={()=>!bulkMode&&onOpenWork(w)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,gap:8}}>
                <div style={{minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4,flexWrap:"wrap"}}><SBadge status={w.status}/><div style={{display:"flex",gap:2}}>{Array.from({length:PRIORITY_STARS[w.priority]||1}).map((_,i)=><span key={i} style={{color:PRIORITY_COLOR[w.priority],fontSize:10}}>★</span>)}</div>{isOverdue(w.deadline,w.status)&&<span style={{background:C.danger+"22",color:C.danger,borderRadius:20,padding:"1px 8px",fontSize:10,fontWeight:700}}>Overdue</span>}</div>
                  <div style={{color:T.text,fontWeight:700,fontSize:bp.isMobile?13:15}}>{w.title}</div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:6}}>{w.category&&<span style={{background:T.card,color:T.muted,borderRadius:6,padding:"2px 8px",fontSize:11}}>{w.category}</span>}{w.tags?.slice(0,2).map(t=><span key={t} style={{background:C.accent+"22",color:C.accent,borderRadius:6,padding:"2px 8px",fontSize:11}}>{t}</span>)}</div>
                </div>
                <div style={{textAlign:"right",flexShrink:0}}><div style={{color:T.text,fontWeight:800,fontSize:14}}>₹{(w.budget||0).toLocaleString()}</div><div style={{color:w.paid?C.success:C.danger,fontSize:11,fontWeight:700}}>{w.paid?"✓ Paid":"Pending"}</div></div>
              </div>
              {w.deadline&&<div style={{color:isOverdue(w.deadline,w.status)?C.danger:T.muted,fontSize:11}}>📅 {fmtDate(w.deadline)}</div>}
              {timeTrackers[w.id]&&<div style={{color:T.muted,fontSize:11,marginTop:4}}>⏱ {getTimerDisplay(w.id)}</div>}
            </div>
          </div>
        </div>
      ))}
      {allWorks.length===0&&<Empty icon="🎯" msg="No works yet for this client" btnLabel="+ Add Work" onBtnClick={onAddWork}/>}
    </div>
  );
}

// ── Analytics View ────────────────────────────────────────────────────────────
function AnalyticsView({T,bp,monthStats,bestTypes,clients,works,analyticsMonth,setAnalyticsMonth,getClientHealth,clientWorks}){
  const hConfig={vip:{color:C.success,bg:"rgba(34,197,94,0.1)",label:"VIP 🟢"},normal:{color:C.warning,bg:"rgba(245,158,11,0.1)",label:"Normal 🟡"},problem:{color:C.danger,bg:"rgba(239,68,68,0.1)",label:"Problem 🔴"},new:{color:"#6B7280",bg:"#1C2035",label:"New ⚪"}};
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <h2 style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,margin:0}}>📈 Analytics</h2>
        <select value={analyticsMonth} onChange={e=>setAnalyticsMonth(+e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"8px 14px",fontSize:13,outline:"none"}}>
          <option value={-1}>📊 All Time</option>
          {MONTHS.map((m,i)=><option key={i} value={i}>{m} {new Date().getFullYear()}</option>)}
        </select>
      </div>
      <div style={{display:"grid",gridTemplateColumns:bp.isMobile?"repeat(2,1fr)":"repeat(3,1fr)",gap:12,marginBottom:20}}>
        {[{label:"Total Works",value:monthStats.total,color:C.accent,icon:"📋"},{label:"Completed",value:monthStats.completed,color:C.success,icon:"✅"},{label:"Revenue",value:`₹${monthStats.revenue.toLocaleString()}`,color:C.accent,icon:"💰"},{label:"Received",value:`₹${monthStats.received.toLocaleString()}`,color:C.success,icon:"💳"},{label:"Revisions",value:monthStats.revisions,color:C.purple,icon:"🔄"},{label:"Active Clients",value:monthStats.clients,color:"#38BDF8",icon:"👥"}].map(({label,value,color,icon})=>(
          <div key={label} style={{background:T.surface,borderRadius:14,padding:"18px",border:`1px solid ${T.border}`}}><div style={{fontSize:22,marginBottom:6}}>{icon}</div><div style={{color,fontWeight:900,fontSize:22,marginBottom:4}}>{value}</div><div style={{color:T.muted,fontSize:12}}>{label}</div></div>
        ))}
      </div>
      {/* Best Work Type */}
      <div style={{background:T.surface,borderRadius:14,padding:"18px",border:`1px solid ${T.border}`,marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:14,marginBottom:14}}>🏆 Best Work Type by Revenue</div>
        {bestTypes.length===0&&<Empty icon="📊" msg="Add works to see analytics"/>}
        {bestTypes.map(([cat,data],i)=>(
          <div key={cat} style={{marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><div style={{width:24,height:24,borderRadius:6,background:C.accent+"22",color:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800}}>{i+1}</div><span style={{color:T.text,fontWeight:600,fontSize:13}}>{cat}</span><span style={{color:T.muted,fontSize:11}}>{data.count} works</span></div>
              <span style={{color:C.accent,fontWeight:700,fontSize:13}}>₹{data.revenue.toLocaleString()}</span>
            </div>
            <div style={{background:T.card,borderRadius:4,height:6,overflow:"hidden"}}><div style={{height:"100%",background:C.accent,width:`${bestTypes[0]?Math.min(100,data.revenue/bestTypes[0][1].revenue*100):0}%`,borderRadius:4,transition:"width 0.4s"}}/></div>
          </div>
        ))}
      </div>
      <div style={{background:T.surface,borderRadius:14,padding:"18px",border:`1px solid ${T.border}`}}>
        <div style={{fontWeight:700,fontSize:14,marginBottom:14}}>Client Health Score</div>
        {clients.map(c=>{const h=hConfig[getClientHealth(c.id)];const cw=clientWorks(c.id);return(<div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}`,gap:10}}><div style={{display:"flex",alignItems:"center",gap:10}}><Av name={c.name} size={34}/><div><div style={{color:T.text,fontWeight:600,fontSize:13}}>{c.name}</div><div style={{color:T.muted,fontSize:11}}>{cw.length} works · {cw.filter(w=>w.paid).length} paid</div></div></div><div style={{background:h.bg,color:h.color,borderRadius:20,padding:"4px 12px",fontSize:11,fontWeight:700}}>{h.label}</div></div>);})}
        {clients.length===0&&<Empty icon="👥" msg="Add your first client to get started!" btnLabel="+ Add Client" onBtnClick={onAddClient}/>}
      </div>
    </div>
  );
}


// ── Work Detail ───────────────────────────────────────────────────────────────
function WorkDetail({work,T,bp,clients,businessProfile,timer,timerDisplay,onAdvance,onRevision,onProgress,onDelivery,onPayment,onNoteChange,onWhatsApp,onDuplicate,onStartTimer,onStopTimer,invoiceDefaults}){
  const[revNote,setRevNote]=useState("");
  const[progLine,setProgLine]=useState("");
  const[noteText,setNoteText]=useState(work.notes||"");
  const noteTimer=useRef(null);
  const idx=STATUS_FLOW.indexOf(work.status);
  const cl=clients.find(c=>c.id===work.client_id);
  const p={background:T.surface,borderRadius:14,padding:bp.isMobile?"14px":"18px",border:`1px solid ${T.border}`,marginBottom:14};
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 13px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};

  return(
    <div>
      <div style={p}>
        <div style={{color:C.muted,fontSize:12,fontWeight:700,marginBottom:4}}>{cl?.name?.toUpperCase()||"CLIENT"}</div>
        <div style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,marginBottom:6}}>{work.title}</div>
        <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:10}}>
          {work.deadline&&<div style={{color:isOverdue(work.deadline,work.status)?C.danger:T.muted,fontSize:12}}>📅 {fmtDate(work.deadline)}{isOverdue(work.deadline,work.status)?" 🚨":""}</div>}
          {work.category&&<span style={{background:T.card,color:T.muted,borderRadius:6,padding:"2px 8px",fontSize:11}}>{work.category}</span>}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{work.tags?.map(t=><span key={t} style={{background:C.accent+"22",color:C.accent,border:`1px solid ${C.accent}33`,borderRadius:20,padding:"3px 10px",fontSize:11,fontWeight:600}}>{t}</span>)}</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button onClick={()=>onWhatsApp("status")} style={{background:"#25D366",color:"#fff",border:"none",borderRadius:10,padding:"7px 12px",fontWeight:700,fontSize:12}}>📤 WA</button>
            <button onClick={onDuplicate} style={{background:T.card,color:T.muted,border:`1px solid ${T.border}`,borderRadius:10,padding:"7px 12px",fontWeight:700,fontSize:12}}>📋 Copy</button>
          </div>
        </div>
      </div>

      {/* Time Tracker */}
      <div style={p}>
        <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:12,letterSpacing:"0.06em"}}>⏱ TIME TRACKER</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{color:timer?.running?C.success:T.text,fontWeight:900,fontSize:32}}>{timerDisplay}</div>
          {!timer?.running
            ?<button onClick={onStartTimer} style={{background:C.success,color:"#fff",border:"none",borderRadius:10,padding:"10px 22px",fontWeight:700,fontSize:13}}>▶ Start</button>
            :<button onClick={onStopTimer} style={{background:C.danger,color:"#fff",border:"none",borderRadius:10,padding:"10px 22px",fontWeight:700,fontSize:13}}>⏹ Stop</button>
          }
        </div>
        {timer?.running&&<div style={{color:C.success,fontSize:12,marginTop:8,display:"flex",alignItems:"center",gap:6}}><span style={{width:6,height:6,borderRadius:"50%",background:C.success,display:"inline-block",animation:"pulse 1.5s infinite"}}/>Recording time…</div>}
      </div>

      {/* Status */}
      <div style={p}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{color:T.muted,fontSize:11,fontWeight:700,letterSpacing:"0.06em"}}>CURRENT STATUS</div>
          <div style={{color:STATUS_COLOR[work.status],fontWeight:800,fontSize:13}}>{work.status}</div>
        </div>
        <div style={{height:6,background:T.card,borderRadius:4,overflow:"hidden",marginBottom:10}}><div style={{height:"100%",background:STATUS_COLOR[work.status],width:`${(idx/(STATUS_FLOW.length-1))*100}%`,borderRadius:4,transition:"width 0.4s"}}/></div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
          {STATUS_FLOW.map((st,i)=>(
            <div key={st} style={{textAlign:"center",flex:1}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:i<=idx?STATUS_COLOR[work.status]:T.border,margin:"0 auto 4px",border:i===idx?`2px solid ${STATUS_COLOR[work.status]}`:""}}/>
              <div style={{color:i<=idx?T.text:T.muted,fontSize:9,fontWeight:i===idx?700:400,display:bp.isMobile?"none":"block"}}>{st}</div>
            </div>
          ))}
        </div>
        <div style={{color:T.muted,fontSize:11,textAlign:"center",marginBottom:12}}>Step {idx+1} of {STATUS_FLOW.length}</div>
        {work.status!=="Completed"
          ?<button onClick={onAdvance} style={{width:"100%",background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"13px",fontWeight:700,fontSize:14}}>Advance Status →</button>
          :<div style={{background:C.success+"22",color:C.success,borderRadius:10,padding:"13px",textAlign:"center",fontWeight:700}}>✅ Project Complete!</div>
        }
      </div>

      {/* Delivery & Payment */}
      <div style={p}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div>
            <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8,letterSpacing:"0.06em"}}>▶ DELIVERY</div>
            <button onClick={onDelivery} style={{width:"100%",background:work.delivered?"rgba(34,197,94,0.15)":T.card,color:work.delivered?C.success:T.muted,border:`1.5px solid ${work.delivered?C.success:T.border}`,borderRadius:10,padding:"11px 8px",fontWeight:700,fontSize:bp.isMobile?11:12,textAlign:"center"}}>
              {work.delivered?"✓ Delivered":"○ Mark Delivered"}
            </button>
          </div>
          <div>
            <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8,letterSpacing:"0.06em"}}>⚡ ADVANCE</div>
            <button onClick={()=>onPayment(work.advance_received?"none":"advance")} style={{width:"100%",background:work.advance_received?"rgba(108,99,255,0.2)":T.card,color:work.advance_received?C.accent:T.muted,border:`1.5px solid ${work.advance_received?C.accent:T.border}`,borderRadius:10,padding:"11px 8px",fontWeight:700,fontSize:bp.isMobile?11:12,textAlign:"center"}}>
              {work.advance_received?"✓ Adv. Received":"○ Adv. Received"}
            </button>
          </div>
        </div>
        {!work.paid&&work.advance_received&&<button onClick={()=>onPayment("full")} style={{width:"100%",background:C.success,color:"#fff",border:"none",borderRadius:10,padding:"11px",fontWeight:700,fontSize:13,marginBottom:12}}>💰 Mark Full Payment Received</button>}
        {work.paid&&<div style={{background:"rgba(34,197,94,0.15)",color:C.success,borderRadius:10,padding:"10px",textAlign:"center",fontWeight:700,fontSize:13,marginBottom:12}}>✅ Full Payment Received!</div>}
        <div style={{background:T.bg,borderRadius:10,padding:"12px 14px"}}>
          {[["Total Budget",`₹${(work.budget||0).toLocaleString()}`,null],["Advance",`₹${(work.advance||0).toLocaleString()}`,C.success],["Remaining",`₹${((work.budget||0)-(work.advance||0)).toLocaleString()}`,work.paid?C.success:C.danger]].map(([l,v,c])=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${T.border}`}}><span style={{color:T.muted,fontSize:13}}>{l}</span><span style={{color:c||T.text,fontWeight:700,fontSize:14}}>{v}</span></div>
          ))}
        </div>
      </div>

      {/* Invoice */}
      <div style={p}>
        <button onClick={()=>generateGSTInvoice(work,cl,businessProfile,invoiceDefaults,timerDisplay)} style={{width:"100%",background:T.card,color:T.text,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
          🧾 Generate GST Invoice
        </button>
      </div>

      {/* Revisions */}
      <div style={p}>
        <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:12,letterSpacing:"0.06em"}}>REVISIONS ({work.revisions.length})</div>
        {work.revisions.map((r,i)=>(
          <div key={r.id} style={{display:"flex",alignItems:"flex-start",gap:8,padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div style={{width:20,height:20,borderRadius:"50%",background:C.accent+"22",color:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:800,flexShrink:0}}>{i+1}</div>
            <div style={{flex:1,color:T.text,fontSize:13}}>{r.note}</div>
            <div style={{color:T.muted,fontSize:10,flexShrink:0}}>{fmt(r.created_at)}</div>
          </div>
        ))}
        {work.revisions.length===0&&<div style={{color:T.muted,fontSize:13,padding:"10px 0"}}>No revisions yet</div>}
        <div style={{display:"flex",gap:8,marginTop:12}}>
          <input style={{...inp,flex:1}} placeholder="Log revision…" value={revNote} onChange={e=>setRevNote(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&revNote.trim()){onRevision(revNote.trim());setRevNote("");}}}/>
          <button onClick={()=>{if(revNote.trim()){onRevision(revNote.trim());setRevNote("");}}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 16px",fontWeight:700,fontSize:14}}>+</button>
        </div>
        {work.revisions.length>0&&<button onClick={()=>onWhatsApp("revision")} style={{marginTop:10,width:"100%",background:"#25D366",color:"#fff",border:"none",borderRadius:10,padding:"10px",fontWeight:700,fontSize:12}}>📤 Send Revision Update on WhatsApp</button>}
      </div>

      {/* Notes + Progress */}
      <div style={p}>
        <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:10,letterSpacing:"0.06em"}}>WORKSPACE NOTES <span style={{color:T.muted,fontSize:10,fontWeight:400}}>🔄 Auto-saving</span></div>
        <textarea style={{...inp,height:80,resize:"none",marginBottom:14}} value={noteText} onChange={e=>{setNoteText(e.target.value);clearTimeout(noteTimer.current);noteTimer.current=setTimeout(()=>onNoteChange(e.target.value),800);}} placeholder="Ideas, meeting notes…"/>
        <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8,letterSpacing:"0.06em"}}>DAILY PROGRESS</div>
        {work.progress.slice(-4).map((p,i)=>(
          <div key={p.id||i} style={{display:"flex",gap:8,padding:"5px 0",borderBottom:`1px solid ${T.border}`,alignItems:"flex-start"}}>
            <span style={{color:C.accent,fontSize:10,flexShrink:0,paddingTop:2}}>{fmt(p.created_at)}</span>
            <span style={{color:T.text,fontSize:12}}>· {p.line}</span>
          </div>
        ))}
        <div style={{display:"flex",gap:8,marginTop:10}}>
          <input style={{...inp,flex:1}} placeholder="Today's update…" value={progLine} onChange={e=>setProgLine(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&progLine.trim()){onProgress(progLine.trim());setProgLine("");}}}/>
          <button onClick={()=>{if(progLine.trim()){onProgress(progLine.trim());setProgLine("");}}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 16px",fontWeight:700,fontSize:13}}>Save</button>
        </div>
      </div>

      {/* Timeline */}
      <div style={p}>
        <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:14,letterSpacing:"0.06em"}}>PROJECT HISTORY</div>
        <div style={{position:"relative",paddingLeft:24}}>
          <div style={{position:"absolute",left:8,top:6,bottom:6,width:2,background:T.border,borderRadius:2}}/>
          {[...work.timeline].reverse().map((t,i)=>(
            <div key={i} style={{position:"relative",paddingBottom:12}}>
              <div style={{position:"absolute",left:-24,top:2,width:10,height:10,borderRadius:"50%",background:i===0?C.accent:T.border,border:i===0?`2px solid ${C.accent}`:""}}/>
              <div style={{color:T.text,fontSize:13,fontWeight:600}}>{t.event}</div>
              <div style={{color:T.muted,fontSize:11,marginTop:2}}>{fmt(t.created_at)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Modals ────────────────────────────────────────────────────────────────────
function ReportModal({T,bp,client,works,businessProfile,onClose}){
  const total=works.reduce((a,w)=>a+(w.budget||0),0);
  const received=works.reduce((a,w)=>a+(w.paid?(w.budget||0):w.advance_received?(w.advance||0):0),0);
  const printReport=()=>{
    const biz=businessProfile;
    const win=window.open("","_blank");
    win.document.write(`<!DOCTYPE html><html><head><title>Report-${client.name}</title><style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Inter,sans-serif;padding:32px;color:#111;max-width:800px;margin:0 auto}h1{color:#6C63FF;margin-bottom:4px}.boxes{display:flex;gap:12px;margin:20px 0}.box{background:#f4f5fb;padding:14px 20px;border-radius:10px;min-width:140px}.box b{display:block;font-size:20px;margin-bottom:4px}.box span{font-size:12px;color:#6b7280}table{width:100%;border-collapse:collapse;margin:20px 0}th{background:#f4f5fb;padding:10px 14px;text-align:left;font-size:12px;font-weight:700;color:#6b7280;text-transform:uppercase}td{padding:10px 14px;border-bottom:1px solid #e5e7eb;font-size:13px}.badge{display:inline-block;padding:2px 10px;border-radius:20px;font-size:11px;font-weight:700}.paid{background:#22C55E22;color:#22C55E}.pending{background:#EF444422;color:#EF4444}.advance{background:#F59E0B22;color:#F59E0B}footer{margin-top:32px;color:#9ca3af;font-size:12px;text-align:center;border-top:1px solid #e5e7eb;padding-top:16px}</style></head><body>
    <h1>◈ ${biz.name||"Workflow"} — Report</h1>
    <h2 style="font-size:20px;margin-top:8px">${client.name}${client.company?` · <span style="color:#6b7280;font-weight:400">${client.company}</span>`:""}</h2>
    ${client.phone?`<p style="color:#6b7280;font-size:13px;margin-top:4px">📱 ${client.phone}</p>`:""}
    <div class="boxes"><div class="box"><b style="color:#6C63FF">₹${total.toLocaleString()}</b><span>Total Budget</span></div><div class="box"><b style="color:#22C55E">₹${received.toLocaleString()}</b><span>Received</span></div><div class="box"><b style="color:#EF4444">₹${(total-received).toLocaleString()}</b><span>Pending</span></div></div>
    <table><tr><th>Work</th><th>Category</th><th>Status</th><th>Revisions</th><th>Delivered</th><th>Payment</th></tr>${works.map(w=>`<tr><td><b>${w.title}</b></td><td>${w.category||"—"}</td><td>${w.status}</td><td>${w.revisions.length}</td><td>${w.delivered?"✓":"No"}</td><td><span class="${w.paid?"paid":w.advance_received?"advance":"pending"}">${w.paid?"Full Paid":w.advance_received?"Advance":"Pending"}</span></td></tr>`).join("")}</table>
    <footer>Generated by ◈ ${biz.name||"Workflow"} · ${new Date().toLocaleString("en-IN")} · workflow.loytro.com</footer>
    </body></html>`);
    win.document.close();win.print();
  };
  const whatsapp=()=>{
    const msg=`*◈ Workflow Report*\n*Client:* ${client.name}\n*Works:* ${works.length}\n*Budget:* ₹${total.toLocaleString()}\n*Received:* ₹${received.toLocaleString()}\n*Pending:* ₹${(total-received).toLocaleString()}\n\n${works.map(w=>`• ${w.title} — ${w.status} ${w.paid?"✓ Paid":""}`).join("\n")}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`,"_blank");
  };
  return(
    <div style={{position:"fixed",inset:0,background:"#00000095",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16,backdropFilter:"blur(6px)"}}>
      <div style={{background:T.surface,borderRadius:18,padding:bp.isMobile?"16px":"24px",width:"100%",maxWidth:500,maxHeight:"90vh",overflowY:"auto",border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}><div style={{color:T.text,fontWeight:800,fontSize:16}}>📄 Report — {client.name}</div><button onClick={onClose} style={{background:"none",border:"none",color:T.muted,fontSize:22}}>✕</button></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
          {[["Budget",total,C.accent],["Received",received,C.success],["Pending",total-received,C.danger]].map(([l,v,c])=>(
            <div key={l} style={{background:T.card,borderRadius:10,padding:"14px 10px",textAlign:"center",border:`1px solid ${T.border}`}}><div style={{color:c,fontWeight:900,fontSize:18}}>₹{v.toLocaleString()}</div><div style={{color:T.muted,fontSize:11,marginTop:3}}>{l}</div></div>
          ))}
        </div>
        {works.map(w=>(
          <div key={w.id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"9px 0",borderBottom:`1px solid ${T.border}`,gap:8}}>
            <div style={{minWidth:0}}><div style={{color:T.text,fontWeight:600,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title}</div><div style={{color:T.muted,fontSize:11}}>{w.revisions.length} rev · {w.delivered?"Delivered":"Pending"}</div></div>
            <div style={{textAlign:"right",flexShrink:0}}><SBadge status={w.status}/><div style={{color:w.paid?C.success:w.advance_received?C.warning:C.danger,fontSize:11,marginTop:4,fontWeight:700}}>{w.paid?"Paid":w.advance_received?"Advance":"Pending"}</div></div>
          </div>
        ))}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:16}}>
          <button onClick={whatsapp} style={{background:"#25D366",color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:13}}>📤 WhatsApp</button>
          <button onClick={printReport} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:13}}>🖨️ Print PDF</button>
        </div>
        <button onClick={onClose} style={{width:"100%",background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"11px",fontWeight:600,fontSize:13,marginTop:10}}>Close</button>
      </div>
    </div>
  );
}

function AddClientModal({T,bp,onSave,onClose}){
  const[f,setF]=useState({name:"",phone:"",email:"",company:"",notes:""});
  const set=k=>e=>setF(p=>({...p,[k]:e.target.value}));
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"12px 14px",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  return(
    <div style={{position:"fixed",inset:0,background:"#00000095",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16,backdropFilter:"blur(6px)"}}>
      <div style={{background:T.surface,borderRadius:18,padding:bp.isMobile?"16px":"24px",width:"100%",maxWidth:420,border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}><div style={{color:T.text,fontWeight:800,fontSize:16}}>👤 Add Client</div><button onClick={onClose} style={{background:"none",border:"none",color:T.muted,fontSize:22}}>✕</button></div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <input style={inp} placeholder="Client Name *" value={f.name} onChange={set("name")}/>
          <input style={inp} placeholder="Phone" value={f.phone} onChange={set("phone")} type="tel"/>
          <input style={inp} placeholder="Email" value={f.email} onChange={set("email")} type="email"/>
          <input style={inp} placeholder="Company" value={f.company} onChange={set("company")}/>
          <textarea style={{...inp,height:70,resize:"none"}} placeholder="Notes" value={f.notes} onChange={set("notes")}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:16}}>
          <button onClick={()=>{if(f.name.trim())onSave(f);}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14}}>Save</button>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"13px",fontWeight:600,fontSize:14}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function AddWorkModal({T,bp,clientId,categories,onSave,onClose}){
  const[f,setF]=useState({client_id:clientId,title:"",category:categories[0]||"Reel",description:"",deadline:"",priority:"Medium",tags:[],budget:"",advance:""});
  const set=k=>e=>setF(p=>({...p,[k]:e.target.value}));
  const toggleTag=t=>setF(p=>({...p,tags:p.tags.includes(t)?p.tags.filter(x=>x!==t):[...p.tags,t]}));
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"12px 14px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  return(
    <div style={{position:"fixed",inset:0,background:"#00000095",display:"flex",alignItems:bp.isMobile?"flex-end":"center",justifyContent:"center",zIndex:200,backdropFilter:"blur(6px)"}}>
      <div style={{background:T.surface,borderRadius:bp.isMobile?"18px 18px 0 0":"18px",padding:bp.isMobile?"18px 16px 24px":"24px",width:"100%",maxWidth:480,maxHeight:bp.isMobile?"92vh":"88vh",overflowY:"auto",border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}><div style={{color:T.text,fontWeight:800,fontSize:16}}>🎯 New Work Item</div><button onClick={onClose} style={{background:"none",border:"none",color:T.muted,fontSize:22}}>✕</button></div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <input style={inp} placeholder="Work Title *" value={f.title} onChange={set("title")}/>
          <select style={{...inp,cursor:"pointer"}} value={f.category} onChange={set("category")}>{categories.map(c=><option key={c}>{c}</option>)}</select>
          <textarea style={{...inp,height:60,resize:"none"}} placeholder="Description" value={f.description} onChange={set("description")}/>
          <input style={inp} type="date" value={f.deadline} onChange={set("deadline")}/>
          <div><div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8}}>PRIORITY</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
              {PRIORITIES.map((p,i)=><button key={p} onClick={()=>setF(prev=>({...prev,priority:p}))} style={{borderRadius:10,padding:"10px 4px",fontWeight:700,fontSize:12,textAlign:"center",background:f.priority===p?PRIORITY_COLOR[p]+"22":T.card,color:f.priority===p?PRIORITY_COLOR[p]:T.muted,border:`1.5px solid ${f.priority===p?PRIORITY_COLOR[p]:T.border}`}}>{"★".repeat(i+1)}<br/>{p}</button>)}
            </div>
          </div>
          <div><div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8}}>TAGS</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>{TAGS.map(t=><button key={t} onClick={()=>toggleTag(t)} style={{background:f.tags.includes(t)?C.accent:T.card,color:f.tags.includes(t)?"#fff":T.muted,border:`1px solid ${f.tags.includes(t)?C.accent:T.border}`,borderRadius:20,padding:"6px 12px",fontSize:11,fontWeight:600}}>{t}{f.tags.includes(t)?" ✕":" +"}</button>)}</div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <input style={inp} type="number" placeholder="Budget ₹" value={f.budget} onChange={set("budget")}/>
            <input style={inp} type="number" placeholder="Advance ₹" value={f.advance} onChange={set("advance")}/>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:16}}>
          <button onClick={()=>{if(f.title.trim())onSave(f);}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14}}>Create Work</button>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"13px",fontWeight:600,fontSize:14}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function QuickAdd({T,bp,clients,categories,onSave,onClose}){
  const[title,setTitle]=useState(""); const[clientId,setClientId]=useState(clients[0]?.id||""); const[category,setCategory]=useState(categories[0]||"Reel");
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"12px 14px",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  return(
    <div style={{position:"fixed",inset:0,background:"#00000095",display:"flex",alignItems:bp.isMobile?"flex-end":"center",justifyContent:"center",zIndex:200,backdropFilter:"blur(6px)"}}>
      <div style={{background:T.surface,borderRadius:bp.isMobile?"18px 18px 0 0":"18px",padding:"20px",width:"100%",maxWidth:400,border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}><div style={{color:T.text,fontWeight:800,fontSize:16}}>⚡ Quick Add</div><button onClick={onClose} style={{background:"none",border:"none",color:T.muted,fontSize:22}}>✕</button></div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <input style={inp} placeholder="Work title *" value={title} onChange={e=>setTitle(e.target.value)} autoFocus/>
          <select style={{...inp,cursor:"pointer"}} value={clientId} onChange={e=>setClientId(e.target.value)}>{clients.length===0&&<option>Add a client first</option>}{clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}</select>
          <select style={{...inp,cursor:"pointer"}} value={category} onChange={e=>setCategory(e.target.value)}>{categories.map(c=><option key={c}>{c}</option>)}</select>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:16}}>
          <button onClick={()=>{if(title.trim()&&clientId)onSave({client_id:clientId,title:title.trim(),category,priority:"Medium",tags:[],budget:0,advance:0});}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14}}>Create →</button>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"13px",fontWeight:600,fontSize:14}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── Helper Components ─────────────────────────────────────────────────────────
function PinnedNoteInput({T,onAdd}){
  const[text,setText]=useState("");
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 13px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  return(
    <div style={{background:T.surface,borderRadius:14,padding:"14px 18px",border:`1px solid ${T.border}`,marginBottom:14}}>
      <div style={{fontWeight:700,fontSize:13,color:C.warning,marginBottom:10}}>📌 Pin a Note</div>
      <div style={{display:"flex",gap:8}}>
        <input style={{...inp,flex:1}} placeholder="Quick note to pin…" value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&text.trim()){onAdd(text.trim());setText("");}}}/>
        <button onClick={()=>{if(text.trim()){onAdd(text.trim());setText("");}}} style={{background:C.warning,color:"#fff",border:"none",borderRadius:10,padding:"10px 16px",fontWeight:700,fontSize:13}}>📌</button>
      </div>
    </div>
  );
}

function CategoryAdder({T,onAdd}){
  const[cat,setCat]=useState("");
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 13px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  return(
    <div style={{display:"flex",gap:8}}>
      <input style={{...inp,flex:1}} placeholder="New category name…" value={cat} onChange={e=>setCat(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&cat.trim()){onAdd(cat.trim());setCat("");}}}/>
      <button onClick={()=>{if(cat.trim()){onAdd(cat.trim());setCat("");}}} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 16px",fontWeight:700,fontSize:13}}>+ Add</button>
    </div>
  );
}

function PasswordChanger({T,notify}){
  const[newPass,setNewPass]=useState(""); const[loading,setLoading]=useState(false);
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 13px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  const change=async()=>{
    if(!newPass||newPass.length<6){notify("Min 6 characters","error");return;}
    setLoading(true);
    try{
      const res=await fetch(`${SB_URL}/auth/v1/user`,{method:"PUT",headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":"application/json"},body:JSON.stringify({password:newPass})});
      if(!res.ok)throw new Error("Failed");
      notify("Password changed! ✅");setNewPass("");
    }catch(e){notify("Error: "+e.message,"error");}finally{setLoading(false);}
  };
  return(
    <div style={{display:"flex",gap:8}}>
      <input style={{...inp,flex:1}} type="password" placeholder="New password (min 6 chars)" value={newPass} onChange={e=>setNewPass(e.target.value)}/>
      <button onClick={change} disabled={loading} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 16px",fontWeight:700,fontSize:13,opacity:loading?0.7:1}}>{loading?"...":"Change"}</button>
    </div>
  );
}

// ── Shared ────────────────────────────────────────────────────────────────────
const Av=({name,size=44})=>{const colors=[C.accent,"#22C55E","#F59E0B","#EF4444","#38BDF8","#A78BFA"];const color=colors[(name?.charCodeAt(0)||0)%colors.length];return<div style={{width:size,height:size,borderRadius:"50%",background:color+"33",color,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:size*0.38,flexShrink:0,border:`1.5px solid ${color}44`}}>{name?.[0]?.toUpperCase()||"?"}</div>;};
const SBadge=({status})=>{const c=STATUS_COLOR[status]||"#6B7280";return<span style={{background:c+"22",color:c,border:`1px solid ${c}44`,borderRadius:20,padding:"3px 10px",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{status}</span>;};
const Empty=({icon,msg,btnLabel,onBtnClick})=>(<div style={{textAlign:"center",padding:"32px 16px",color:"#6B7280"}}>
  <div style={{fontSize:40,marginBottom:10}}>{icon}</div>
  <div style={{fontSize:14,fontWeight:500,marginBottom:btnLabel?16:0}}>{msg}</div>
  {btnLabel&&onBtnClick&&<button onClick={onBtnClick} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"10px 22px",fontWeight:700,fontSize:13,cursor:"pointer"}}>{btnLabel}</button>}
</div>);
const Toast=({msg,type})=><div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:type==="success"?C.success:C.danger,color:"#fff",padding:"12px 22px",borderRadius:12,fontWeight:700,fontSize:13,zIndex:9999,boxShadow:"0 4px 24px #0008",whiteSpace:"nowrap"}}>{type==="success"?"✓":"✕"} {msg}</div>;
const Loader=()=>(<div style={{minHeight:"100vh",background:C.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16,fontFamily:"'Inter',system-ui,sans-serif"}}><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style><div style={{animation:"spin 2s linear infinite"}}><Logo size={42}/></div><div style={{color:C.muted,fontSize:14,fontWeight:600}}>Loading Workflow…</div></div>);

// ── Profile View ──────────────────────────────────────────────────────────────
function ProfileView({T,bp,user,profile,setProfile,notify,clients,works}){
  const[editing,setEditing]=useState(false);
  const[uploading,setUploading]=useState(false);
  const[form,setForm]=useState({
    full_name:profile?.full_name||"",
    profession:profile?.profession||"",
    phone:profile?.phone||"",
    city:profile?.city||"",
    bio:profile?.bio||"",
  });
  const fileRef=useRef(null);
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"11px 14px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};

  useEffect(()=>{
    if(profile){setForm({full_name:profile.full_name||"",profession:profile.profession||"",phone:profile.phone||"",city:profile.city||"",bio:profile.bio||""});}
  },[profile]);

  const saveProfile=async()=>{
    try{
      // Try PATCH first
      const res=await fetch(`${SB_URL}/rest/v1/profiles?id=eq.${user.id}`,{
        method:"PATCH",
        headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":"application/json",Prefer:"return=representation"},
        body:JSON.stringify({...form,updated_at:new Date().toISOString()}),
      });
      const data=await res.json();
      if(!data||data.length===0){
        // Insert if not exists
        await fetch(`${SB_URL}/rest/v1/profiles`,{
          method:"POST",
          headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":"application/json",Prefer:"return=representation"},
          body:JSON.stringify({id:user.id,...form}),
        });
      }
      setProfile(p=>({...p,...form}));
      setEditing(false);
      notify("Profile saved! ✅");
    }catch(e){notify("Error: "+e.message,"error");}
  };

  const uploadPhoto=async(file)=>{
    if(!file)return;
    setUploading(true);
    try{
      const ext=file.name.split(".").pop().toLowerCase();
      const path=`${user.id}/avatar.${ext}`;
      const res=await fetch(`${SB_URL}/storage/v1/object/avatars/${path}`,{
        method:"POST",
        headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":file.type,"x-upsert":"true"},
        body:file,
      });
      if(!res.ok)throw new Error("Upload failed");
      const avatar_url=`${SB_URL}/storage/v1/object/public/avatars/${path}?t=${Date.now()}`;
      await fetch(`${SB_URL}/rest/v1/profiles?id=eq.${user.id}`,{
        method:"PATCH",
        headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`,"Content-Type":"application/json"},
        body:JSON.stringify({avatar_url}),
      });
      setProfile(p=>({...p,avatar_url}));
      notify("Photo updated! 📸");
    }catch(e){notify("Error: "+e.message,"error");}
    finally{setUploading(false);}
  };

  const PROFESSIONS=["Video Editor","Graphic Designer","Web Developer","Photographer","Content Creator","Social Media Manager","UI/UX Designer","Motion Designer","Copywriter","Illustrator","Freelancer","Other"];
  const completedWorks=works.filter(w=>w.status==="Completed").length;
  const totalRevenue=works.reduce((a,w)=>a+(w.paid?(w.budget||0):0),0);
  const initials=(profile?.full_name||user?.email||"W").split(" ").map(n=>n[0]).join("").toUpperCase().slice(0,2);

  return(
    <div style={{maxWidth:560,margin:"0 auto"}}>
      <h2 style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,marginBottom:20}}>👤 My Profile</h2>

      {/* Profile Card */}
      <div style={{background:T.surface,borderRadius:18,padding:bp.isMobile?"20px":"28px",border:`1px solid ${T.border}`,marginBottom:16,textAlign:"center",position:"relative"}}>
        {/* Cover strip */}
        <div style={{position:"absolute",top:0,left:0,right:0,height:70,background:`linear-gradient(135deg,${C.accent}88,${C.purple}88)`,borderRadius:"18px 18px 0 0"}}/>

        {/* Avatar */}
        <div style={{position:"relative",display:"inline-block",marginBottom:12,zIndex:1,marginTop:24}}>
          {profile?.avatar_url
            ?<img src={profile.avatar_url} alt="avatar" style={{width:88,height:88,borderRadius:"50%",objectFit:"cover",border:`4px solid ${T.surface}`,display:"block"}}/>
            :<div style={{width:88,height:88,borderRadius:"50%",background:`linear-gradient(135deg,${C.accent},${C.purple})`,border:`4px solid ${T.surface}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:30,fontWeight:900,color:"#fff"}}>
              {initials}
            </div>
          }
          <button onClick={()=>fileRef.current?.click()}
            style={{position:"absolute",bottom:2,right:2,width:28,height:28,borderRadius:"50%",background:C.accent,border:`2px solid ${T.surface}`,color:"#fff",fontSize:13,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
            {uploading?"⏳":"📷"}
          </button>
          <input ref={fileRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&uploadPhoto(e.target.files[0])}/>
        </div>

        <div style={{color:T.text,fontWeight:800,fontSize:20,marginBottom:4}}>{profile?.full_name||"Your Name"}</div>
        {profile?.profession&&<div style={{display:"inline-block",background:C.accent+"22",color:C.accent,borderRadius:20,padding:"3px 14px",fontSize:13,fontWeight:600,marginBottom:6}}>{profile.profession}</div>}
        <div style={{color:T.muted,fontSize:13,marginTop:4,display:"flex",justifyContent:"center",gap:12,flexWrap:"wrap"}}>
          {profile?.city&&<span>📍 {profile.city}</span>}
          {profile?.phone&&<span>📱 {profile.phone}</span>}
        </div>
        {profile?.bio&&<div style={{color:T.muted,fontSize:13,marginTop:10,lineHeight:1.6,maxWidth:420,margin:"12px auto 0",fontStyle:"italic"}}>"{profile.bio}"</div>}

        <button onClick={()=>setEditing(e=>!e)}
          style={{marginTop:16,background:editing?T.card:C.accent,color:editing?T.muted:"#fff",border:`1px solid ${editing?T.border:C.accent}`,borderRadius:10,padding:"9px 24px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
          {editing?"✕ Cancel":"✏️ Edit Profile"}
        </button>
      </div>

      {/* Edit Form */}
      {editing&&(
        <div style={{background:T.surface,borderRadius:16,padding:bp.isMobile?"16px":"24px",border:`1px solid ${T.border}`,marginBottom:16}}>
          <div style={{color:T.text,fontWeight:700,fontSize:15,marginBottom:16}}>✏️ Edit Your Profile</div>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>FULL NAME</div>
              <input style={inp} placeholder="Your full name" value={form.full_name} onChange={e=>setForm(p=>({...p,full_name:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>PROFESSION / WORK TYPE</div>
              <select style={{...inp,cursor:"pointer"}} value={form.profession} onChange={e=>setForm(p=>({...p,profession:e.target.value}))}>
                <option value="">Select your profession…</option>
                {PROFESSIONS.map(p=><option key={p}>{p}</option>)}
              </select>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>PHONE</div>
                <input style={inp} placeholder="Phone number" type="tel" value={form.phone} onChange={e=>setForm(p=>({...p,phone:e.target.value}))}/>
              </div>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>CITY</div>
                <input style={inp} placeholder="Your city" value={form.city} onChange={e=>setForm(p=>({...p,city:e.target.value}))}/>
              </div>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>BIO</div>
              <textarea style={{...inp,height:80,resize:"none"}} placeholder="Short bio about yourself and your work…" value={form.bio} onChange={e=>setForm(p=>({...p,bio:e.target.value}))}/>
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:16}}>
            <button onClick={saveProfile} style={{background:C.accent,color:"#fff",border:"none",borderRadius:10,padding:"12px",fontWeight:700,fontSize:14}}>💾 Save Profile</button>
            <button onClick={()=>setEditing(false)} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:10,padding:"12px",fontWeight:600,fontSize:14}}>Cancel</button>
          </div>
        </div>
      )}

      {/* Stats */}
      <div style={{background:T.surface,borderRadius:16,padding:bp.isMobile?"16px":"24px",border:`1px solid ${T.border}`,marginBottom:16}}>
        <div style={{color:T.text,fontWeight:700,fontSize:14,marginBottom:14}}>📊 Your Stats</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
          {[
            {label:"Total Clients",value:clients.length,color:C.accent},
            {label:"Works Done",value:completedWorks,color:C.success},
            {label:"Revenue Earned",value:`₹${totalRevenue.toLocaleString()}`,color:C.warning},
          ].map(({label,value,color})=>(
            <div key={label} style={{textAlign:"center",background:T.card,borderRadius:12,padding:"16px 8px",border:`1px solid ${T.border}`}}>
              <div style={{color,fontWeight:900,fontSize:bp.isMobile?16:20,marginBottom:4}}>{value}</div>
              <div style={{color:T.muted,fontSize:10}}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Account Info */}
      <div style={{background:T.surface,borderRadius:16,padding:bp.isMobile?"16px":"24px",border:`1px solid ${T.border}`}}>
        <div style={{color:T.text,fontWeight:700,fontSize:14,marginBottom:14}}>🔐 Account Info</div>
        <div style={{display:"flex",flexDirection:"column",gap:0}}>
          {[
            ["Email",user?.email],
            ["Member Since",user?.created_at?new Date(user.created_at).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}):"-"],
            ["App Version","v9.0 Workflow"],
          ].map(([label,value])=>(
            <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
              <span style={{color:T.muted,fontSize:13}}>{label}</span>
              <span style={{color:T.text,fontSize:13,fontWeight:600}}>{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
// ── Settings View v2 ──────────────────────────────────────────────────────────
function SettingsView({T,bp,user,businessProfile,setBusinessProfile,customCategories,setCustomCategories,DEFAULT_CATEGORIES,clients,works,notify,onLogout,accentColor,setAccentColor,currency,setCurrency,dateFormat,setDateFormat,notifPrefs,setNotifPrefs,invoiceDefaults,setInvoiceDefaults,defaultView,setDefaultView,waTemplates,setWaTemplates,workTemplates,setWorkTemplates}){
  const [tab,setTab]=useState("business");
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"11px 14px",fontSize:13,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  const textarea={...inp,resize:"none",height:70};

  const TABS=[
    {id:"business",label:"🏢 Business",icon:"🏢"},
    {id:"appearance",label:"🎨 Appearance",icon:"🎨"},
    {id:"invoice",label:"🧾 Invoice",icon:"🧾"},
    {id:"notifications",label:"🔔 Alerts",icon:"🔔"},
    {id:"whatsapp",label:"📤 WhatsApp",icon:"📤"},
    {id:"templates",label:"📝 Templates",icon:"📝"},
    {id:"data",label:"🛡️ Data",icon:"🛡️"},
    {id:"account",label:"🔐 Account",icon:"🔐"},
  ];

  const ACCENTS=[
    {name:"Purple",color:"#6C63FF"},
    {name:"Blue",color:"#3B82F6"},
    {name:"Green",color:"#22C55E"},
    {name:"Orange",color:"#F97316"},
    {name:"Pink",color:"#EC4899"},
    {name:"Teal",color:"#14B8A6"},
  ];

  const CURRENCIES=["INR (₹)","USD ($)","AED (د.إ)","GBP (£)","EUR (€)"];
  const DATE_FORMATS=["DD/MM/YYYY","MM/DD/YYYY","YYYY-MM-DD"];

  // Export CSV
  const exportCSV=(type)=>{
    let csv="",filename="";
    if(type==="clients"){
      csv="Name,Company,Phone,Email,Notes\n"+clients.map(c=>`"${c.name||""}","${c.company||""}","${c.phone||""}","${c.email||""}","${c.notes||""}"`).join("\n");
      filename="workflow-clients.csv";
    } else {
      csv="Title,Category,Status,Priority,Budget,Advance,Paid,Delivered,Deadline,Tags\n"+works.map(w=>`"${w.title||""}","${w.category||""}","${w.status||""}","${w.priority||""}","${w.budget||0}","${w.advance||0}","${w.paid}","${w.delivered}","${w.deadline||""}","${(w.tags||[]).join(";")}"`).join("\n");
      filename="workflow-works.csv";
    }
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download=filename;a.click();
    URL.revokeObjectURL(url);
    notify(`${type==="clients"?"Clients":"Works"} exported! 📥`);
  };

  // Delete account
  const [deleteConfirm,setDeleteConfirm]=useState("");
  const deleteAccount=async()=>{
    if(deleteConfirm!=="DELETE"){notify("Type DELETE to confirm","error");return;}
    try{
      await fetch(`${SB_URL}/auth/v1/user`,{method:"DELETE",headers:{apikey:SB_KEY,Authorization:`Bearer ${getToken()}`}});
      notify("Account deleted");
      setTimeout(()=>{localStorage.clear();window.location.reload();},1500);
    }catch(e){notify("Error: "+e.message,"error");}
  };

  // Save template from work
  const [newTpl,setNewTpl]=useState({name:"",category:"Reel",priority:"Medium",budget:""});

  return(
    <div>
      <h2 style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,marginBottom:16}}>⚙️ Settings</h2>

      {/* Tab bar */}
      <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:20,background:T.surface,borderRadius:12,padding:6,border:`1px solid ${T.border}`}}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            style={{background:tab===t.id?accentColor:"none",color:tab===t.id?"#fff":T.muted,border:"none",borderRadius:8,padding:bp.isMobile?"7px 10px":"8px 14px",fontSize:bp.isMobile?11:12,fontWeight:700,cursor:"pointer",transition:"all 0.15s",whiteSpace:"nowrap"}}>
            {bp.isMobile?t.icon:t.label}
          </button>
        ))}
      </div>

      {/* ── BUSINESS PROFILE ── */}
      {tab==="business"&&(
        <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:16,color:T.text}}>🏢 Business Profile</div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {[["Business Name","name","Your business / studio name"],["Tagline","tagline","e.g. Creative Studio · Video Editor"],["Phone","phone","Business phone number"],["Email","email","Business email"],["Address","address","Full address"],["GSTIN","gstin","GST number (optional)"]].map(([label,key,ph])=>(
              <div key={key}>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>{label.toUpperCase()}</div>
                <input style={inp} placeholder={ph} value={businessProfile[key]||""} onChange={e=>setBusinessProfile(p=>({...p,[key]:e.target.value}))}/>
              </div>
            ))}
          </div>
          <button onClick={()=>notify("Business profile saved! ✅")} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:16,cursor:"pointer"}}>Save Profile</button>
        </div>
      )}

      {/* ── APPEARANCE ── */}
      {tab==="appearance"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* Accent Color */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>🎨 Accent Color</div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {ACCENTS.map(a=>(
                <button key={a.color} onClick={()=>setAccentColor(a.color)}
                  style={{display:"flex",flexDirection:"column",alignItems:"center",gap:6,background:"none",border:"none",cursor:"pointer",padding:4}}>
                  <div style={{width:40,height:40,borderRadius:"50%",background:a.color,border:accentColor===a.color?`3px solid ${T.text}`:`3px solid transparent`,transition:"border 0.15s"}}/>
                  <span style={{color:T.muted,fontSize:11}}>{a.name}</span>
                </button>
              ))}
            </div>
            <div style={{marginTop:14,padding:"10px 14px",background:T.card,borderRadius:10,display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:24,height:24,borderRadius:6,background:accentColor}}/>
              <span style={{color:T.text,fontSize:13,fontWeight:600}}>Current: {ACCENTS.find(a=>a.color===accentColor)?.name||"Custom"}</span>
              <span style={{color:T.muted,fontSize:12,marginLeft:"auto"}}>{accentColor}</span>
            </div>
          </div>

          {/* Layout Density */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>📋 Default Work View</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
              {[["list","📄 List","Simple list"],["compact","⚡ Compact","Dense view"],["card","🃏 Cards","Card grid"]].map(([v,label,sub])=>(
                <button key={v} onClick={()=>setDefaultView(v)}
                  style={{background:defaultView===v?accentColor+"22":T.card,border:`1.5px solid ${defaultView===v?accentColor:T.border}`,borderRadius:10,padding:"12px 8px",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:18,marginBottom:4}}>{label.split(" ")[0]}</div>
                  <div style={{color:defaultView===v?accentColor:T.text,fontSize:12,fontWeight:700}}>{label.split(" ")[1]}</div>
                  <div style={{color:T.muted,fontSize:10,marginTop:2}}>{sub}</div>
                </button>
              ))}
            </div>
          </div>

          {/* Currency & Date */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>💰 Currency & Date Format</div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>CURRENCY</div>
                <select style={{...inp,cursor:"pointer"}} value={currency} onChange={e=>setCurrency(e.target.value)}>
                  {CURRENCIES.map(c=><option key={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>DATE FORMAT</div>
                <select style={{...inp,cursor:"pointer"}} value={dateFormat} onChange={e=>setDateFormat(e.target.value)}>
                  {DATE_FORMATS.map(f=><option key={f}>{f}</option>)}
                </select>
              </div>
            </div>
            <button onClick={()=>notify("Preferences saved! ✅")} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:14,cursor:"pointer"}}>Save</button>
          </div>
        </div>
      )}

      {/* ── INVOICE DEFAULTS ── */}
      {tab==="invoice"&&(
        <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:16,color:T.text}}>🧾 Invoice Defaults</div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>DEFAULT DUE DAYS</div>
              <input style={inp} type="number" placeholder="e.g. 7" value={invoiceDefaults.dueDays||""} onChange={e=>setInvoiceDefaults(p=>({...p,dueDays:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>UPI ID</div>
              <input style={inp} placeholder="yourname@upi" value={invoiceDefaults.upiId||""} onChange={e=>setInvoiceDefaults(p=>({...p,upiId:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>BANK ACCOUNT NAME</div>
              <input style={inp} placeholder="Account holder name" value={invoiceDefaults.bankName||""} onChange={e=>setInvoiceDefaults(p=>({...p,bankName:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>ACCOUNT NUMBER</div>
              <input style={inp} placeholder="Bank account number" value={invoiceDefaults.accountNo||""} onChange={e=>setInvoiceDefaults(p=>({...p,accountNo:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>IFSC CODE</div>
              <input style={inp} placeholder="e.g. HDFC0001234" value={invoiceDefaults.ifsc||""} onChange={e=>setInvoiceDefaults(p=>({...p,ifsc:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>PAYMENT TERMS NOTE</div>
              <textarea style={textarea} placeholder="e.g. Payment within 7 days. Late fee 2% per week." value={invoiceDefaults.terms||""} onChange={e=>setInvoiceDefaults(p=>({...p,terms:e.target.value}))}/>
            </div>
            <div>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>INVOICE FOOTER NOTE</div>
              <textarea style={textarea} placeholder="Thank you for your business!" value={invoiceDefaults.footer||""} onChange={e=>setInvoiceDefaults(p=>({...p,footer:e.target.value}))}/>
            </div>
          </div>
          <button onClick={()=>notify("Invoice defaults saved! ✅")} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:14,cursor:"pointer"}}>Save Defaults</button>
        </div>
      )}

      {/* ── NOTIFICATIONS ── */}
      {tab==="notifications"&&(
        <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:6,color:T.text}}>🔔 Notification Preferences</div>
          <div style={{color:T.muted,fontSize:12,marginBottom:16}}>Control which events trigger browser notifications</div>
          {[
            {key:"overdue",label:"🚨 Overdue deadline alert",desc:"When a work deadline passes"},
            {key:"payment",label:"💳 Payment pending reminder",desc:"For completed but unpaid works"},
            {key:"revision",label:"🔄 Revision added",desc:"When a new revision is logged"},
            {key:"delivered",label:"📦 Work delivered",desc:"When work is marked delivered"},
            {key:"completed",label:"✅ Work completed",desc:"When status moves to Completed"},
          ].map(({key,label,desc})=>(
            <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:`1px solid ${T.border}`}}>
              <div>
                <div style={{color:T.text,fontSize:13,fontWeight:600}}>{label}</div>
                <div style={{color:T.muted,fontSize:11,marginTop:2}}>{desc}</div>
              </div>
              <button onClick={()=>setNotifPrefs(p=>({...p,[key]:!p[key]}))}
                style={{width:44,height:24,borderRadius:12,background:notifPrefs[key]?accentColor:T.card,border:`1px solid ${notifPrefs[key]?accentColor:T.border}`,cursor:"pointer",position:"relative",transition:"all 0.2s",flexShrink:0}}>
                <div style={{width:18,height:18,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:notifPrefs[key]?22:2,transition:"left 0.2s"}}/>
              </button>
            </div>
          ))}
          <div style={{marginTop:14,padding:"12px 14px",background:T.card,borderRadius:10,display:"flex",gap:10,alignItems:"flex-start"}}>
            <span style={{fontSize:18}}>💡</span>
            <div style={{color:T.muted,fontSize:12}}>Browser notifications need permission. Click "Allow" when prompted. Works on desktop Chrome/Edge.</div>
          </div>
          <button onClick={async()=>{
            const p=await Notification.requestPermission();
            if(p==="granted"){notify("Notifications enabled! 🔔");}
            else{notify("Permission denied in browser","error");}
          }} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:14,cursor:"pointer"}}>
            Enable Browser Notifications
          </button>
        </div>
      )}

      {/* ── WHATSAPP TEMPLATES ── */}
      {tab==="whatsapp"&&(
        <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:6,color:T.text}}>📤 WhatsApp Message Templates</div>
          <div style={{color:T.muted,fontSize:12,marginBottom:16}}>Use {"{client}"} for client name and {"{work}"} for work title</div>
          {[
            {key:"Started",label:"▶ Started"},
            {key:"In Progress",label:"⏳ In Progress"},
            {key:"Sent",label:"📤 Sent to Client"},
            {key:"Completed",label:"✅ Completed"},
            {key:"Revision",label:"🔄 Revision Update"},
            {key:"Delivered",label:"📦 Delivered"},
          ].map(({key,label})=>(
            <div key={key} style={{marginBottom:14}}>
              <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4,letterSpacing:"0.06em"}}>{label.toUpperCase()}</div>
              <textarea style={{...textarea,height:60}} value={waTemplates[key]||""} onChange={e=>setWaTemplates(p=>({...p,[key]:e.target.value}))} placeholder={`Message for ${key} status…`}/>
            </div>
          ))}
          <button onClick={()=>notify("WhatsApp templates saved! ✅")} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,cursor:"pointer"}}>Save Templates</button>
        </div>
      )}

      {/* ── WORK TEMPLATES ── */}
      {tab==="templates"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {/* Existing templates */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>📝 Work Templates ({workTemplates.length})</div>
            {workTemplates.length===0&&<div style={{color:T.muted,fontSize:13,textAlign:"center",padding:"20px 0"}}>No templates yet. Create one below!</div>}
            {workTemplates.map((tpl,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
                <div>
                  <div style={{color:T.text,fontWeight:600,fontSize:13}}>{tpl.name}</div>
                  <div style={{color:T.muted,fontSize:11,marginTop:2}}>{tpl.category} · {tpl.priority} priority{tpl.budget?` · ₹${tpl.budget}`:""}</div>
                </div>
                <button onClick={()=>setWorkTemplates(p=>p.filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:C.danger,fontSize:16,cursor:"pointer"}}>✕</button>
              </div>
            ))}
          </div>

          {/* Add new template */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>+ Create Template</div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4}}>TEMPLATE NAME</div>
                <input style={inp} placeholder="e.g. Instagram Reel 30sec" value={newTpl.name} onChange={e=>setNewTpl(p=>({...p,name:e.target.value}))}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4}}>CATEGORY</div>
                  <select style={{...inp,cursor:"pointer"}} value={newTpl.category} onChange={e=>setNewTpl(p=>({...p,category:e.target.value}))}>
                    {DEFAULT_CATEGORIES.map(c=><option key={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4}}>PRIORITY</div>
                  <select style={{...inp,cursor:"pointer"}} value={newTpl.priority} onChange={e=>setNewTpl(p=>({...p,priority:e.target.value}))}>
                    {["Low","Medium","High"].map(p=><option key={p}>{p}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:4}}>DEFAULT BUDGET ₹ (optional)</div>
                <input style={inp} type="number" placeholder="e.g. 1500" value={newTpl.budget} onChange={e=>setNewTpl(p=>({...p,budget:e.target.value}))}/>
              </div>
            </div>
            <button onClick={()=>{
              if(!newTpl.name.trim()){notify("Enter template name","error");return;}
              setWorkTemplates(p=>[...p,{...newTpl}]);
              setNewTpl({name:"",category:"Reel",priority:"Medium",budget:""});
              notify("Template saved! 📝");
            }} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:14,cursor:"pointer"}}>Save Template</button>
          </div>

          {/* Categories */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>🏷️ Custom Categories</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
              {customCategories.map(cat=>(
                <div key={cat} style={{background:accentColor+"22",color:accentColor,border:`1px solid ${accentColor}44`,borderRadius:20,padding:"5px 12px",fontSize:12,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
                  {cat}
                  {!DEFAULT_CATEGORIES.includes(cat)&&<button onClick={()=>setCustomCategories(p=>p.filter(c=>c!==cat))} style={{background:"none",border:"none",color:accentColor,cursor:"pointer",fontSize:12,padding:0,lineHeight:1}}>✕</button>}
                </div>
              ))}
            </div>
            <CategoryAdder T={T} onAdd={cat=>{if(cat&&!customCategories.includes(cat)){setCustomCategories(p=>[...p,cat]);notify("Category added!");}}}/>
          </div>
        </div>
      )}

      {/* ── DATA & PRIVACY ── */}
      {tab==="data"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>📥 Export Your Data</div>
            <div style={{color:T.muted,fontSize:13,marginBottom:14,lineHeight:1.6}}>Download all your data as CSV files. You can open them in Excel or Google Sheets.</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <button onClick={()=>exportCSV("clients")} style={{background:T.card,color:T.text,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                👥 Export Clients<br/><span style={{color:T.muted,fontSize:11,fontWeight:400}}>{clients.length} records</span>
              </button>
              <button onClick={()=>exportCSV("works")} style={{background:T.card,color:T.text,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                💼 Export Works<br/><span style={{color:T.muted,fontSize:11,fontWeight:400}}>{works.length} records</span>
              </button>
            </div>
            <button onClick={()=>{
              const all={clients,works:works.map(({revisions,progress,timeline,...w})=>({...w,revisions,progress,timeline}))};
              const blob=new Blob([JSON.stringify(all,null,2)],{type:"application/json"});
              const url=URL.createObjectURL(blob);
              const a=document.createElement("a");a.href=url;a.download="workflow-backup.json";a.click();
              URL.revokeObjectURL(url);
              notify("Full backup downloaded! 💾");
            }} style={{background:accentColor,color:"#fff",border:"none",borderRadius:10,padding:"11px 20px",fontWeight:700,fontSize:13,marginTop:12,cursor:"pointer",width:"100%"}}>
              💾 Download Full Backup (JSON)
            </button>
          </div>

          {/* Delete Account */}
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${C.danger}44`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:6,color:C.danger}}>⚠️ Danger Zone</div>
            <div style={{color:T.muted,fontSize:13,marginBottom:14,lineHeight:1.6}}>Permanently delete your account and all data. This cannot be undone.</div>
            <div style={{color:T.muted,fontSize:12,marginBottom:8}}>Type <b style={{color:T.text}}>DELETE</b> to confirm:</div>
            <div style={{display:"flex",gap:8}}>
              <input style={{...inp,flex:1}} placeholder="Type DELETE here" value={deleteConfirm} onChange={e=>setDeleteConfirm(e.target.value)}/>
              <button onClick={deleteAccount} style={{background:C.danger,color:"#fff",border:"none",borderRadius:10,padding:"11px 18px",fontWeight:700,fontSize:13,cursor:"pointer",flexShrink:0}}>Delete</button>
            </div>
          </div>
        </div>
      )}

      {/* ── ACCOUNT ── */}
      {tab==="account"&&(
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>🔐 Change Password</div>
            <PasswordChanger T={T} notify={notify}/>
          </div>
          <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"16px":"20px",border:`1px solid ${T.border}`}}>
            <div style={{fontWeight:700,fontSize:14,marginBottom:14,color:T.text}}>📱 App Info</div>
            {[["Email",user?.email],["Version","Workflow v10.0"],["Clients",clients.length],["Works",works.length],["Member Since",user?.created_at?new Date(user.created_at).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}):"-"]].map(([l,v])=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 0",borderBottom:`1px solid ${T.border}`}}>
                <span style={{color:T.muted,fontSize:13}}>{l}</span>
                <span style={{color:T.text,fontSize:13,fontWeight:600}}>{v}</span>
              </div>
            ))}
            <button onClick={onLogout} style={{marginTop:14,background:"rgba(239,68,68,0.1)",color:C.danger,border:`1px solid rgba(239,68,68,0.3)`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,cursor:"pointer"}}>🚪 Sign Out</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Calendar View ─────────────────────────────────────────────────────────────
function CalendarView({T,bp,works,clients,onOpenWork,accentColor}){
  const AC=accentColor||"#6C63FF";
  const [currentDate,setCurrentDate]=useState(new Date());
  const [selectedDay,setSelectedDay]=useState(null);

  const year=currentDate.getFullYear();
  const month=currentDate.getMonth();
  const monthName=currentDate.toLocaleDateString("en-IN",{month:"long",year:"numeric"});
  const firstDay=new Date(year,month,1).getDay();
  const daysInMonth=new Date(year,month+1,0).getDate();
  const DAYS=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  const getWorksByDate=(day)=>{
    const dateStr=`${year}-${String(month+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
    return works.filter(w=>w.deadline===dateStr);
  };

  const isToday=(day)=>{
    const t=new Date();
    return t.getDate()===day&&t.getMonth()===month&&t.getFullYear()===year;
  };

  const isPast=(day)=>{
    const d=new Date(year,month,day);
    return d<new Date(new Date().setHours(0,0,0,0));
  };

  const selectedWorks=selectedDay?getWorksByDate(selectedDay):[];
  const STATUS_COLOR={"Not Started":"#6B7280","Started":"#38BDF8","In Progress":"#F59E0B","Sent":"#A78BFA","Completed":"#22C55E"};

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <h2 style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?18:22,margin:0}}>📅 Deadline Calendar</h2>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button onClick={()=>setCurrentDate(new Date(year,month-1,1))} style={{background:T.surface,border:`1px solid ${T.border}`,color:T.text,borderRadius:8,padding:"7px 12px",cursor:"pointer",fontWeight:700}}>‹</button>
          <span style={{color:T.text,fontWeight:700,fontSize:14,minWidth:140,textAlign:"center"}}>{monthName}</span>
          <button onClick={()=>setCurrentDate(new Date(year,month+1,1))} style={{background:T.surface,border:`1px solid ${T.border}`,color:T.text,borderRadius:8,padding:"7px 12px",cursor:"pointer",fontWeight:700}}>›</button>
          <button onClick={()=>setCurrentDate(new Date())} style={{background:AC,color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontWeight:700,fontSize:12}}>Today</button>
        </div>
      </div>

      {/* Legend */}
      <div style={{display:"flex",gap:14,marginBottom:14,flexWrap:"wrap"}}>
        {[["#EF4444","Overdue"],["#F59E0B","Due Today"],[AC,"Has Deadline"],["#22C55E","Completed"]].map(([c,l])=>(
          <div key={l} style={{display:"flex",alignItems:"center",gap:5}}><div style={{width:10,height:10,borderRadius:"50%",background:c}}/><span style={{color:T.muted,fontSize:11}}>{l}</span></div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div style={{background:T.surface,borderRadius:14,padding:bp.isMobile?"12px":"18px",border:`1px solid ${T.border}`,marginBottom:16}}>
        {/* Day headers */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4,marginBottom:8}}>
          {DAYS.map(d=><div key={d} style={{color:T.muted,fontSize:11,fontWeight:700,textAlign:"center",padding:"4px 0"}}>{d}</div>)}
        </div>
        {/* Days grid */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
          {Array.from({length:firstDay}).map((_,i)=><div key={`e${i}`}/>)}
          {Array.from({length:daysInMonth}).map((_,i)=>{
            const day=i+1;
            const dayWorks=getWorksByDate(day);
            const today=isToday(day);
            const past=isPast(day);
            const overdueWks=dayWorks.filter(w=>w.status!=="Completed");
            const hasOverdue=past&&overdueWks.length>0;
            const isSelected=selectedDay===day;
            const isTodayDeadline=!past&&dayWorks.length>0;

            return(
              <div key={day} onClick={()=>setSelectedDay(isSelected?null:day)}
                style={{
                  minHeight:bp.isMobile?40:52,borderRadius:8,padding:bp.isMobile?"4px":"6px",cursor:"pointer",
                  background:isSelected?AC+"33":today?AC+"22":T.card,
                  border:`1.5px solid ${isSelected?AC:today?AC:T.border}`,
                  transition:"all 0.15s",position:"relative"
                }}>
                <div style={{color:today?AC:past&&!dayWorks.length?T.muted:T.text,fontWeight:today?800:dayWorks.length?700:400,fontSize:bp.isMobile?11:13,marginBottom:2}}>{day}</div>
                {dayWorks.slice(0,bp.isMobile?1:3).map((w,wi)=>(
                  <div key={w.id} style={{background:hasOverdue?"#EF444444":w.status==="Completed"?"#22C55E33":AC+"33",borderRadius:3,padding:"1px 4px",marginBottom:1,overflow:"hidden"}}>
                    <div style={{color:hasOverdue?"#EF4444":w.status==="Completed"?"#22C55E":AC,fontSize:9,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title}</div>
                  </div>
                ))}
                {dayWorks.length>3&&!bp.isMobile&&<div style={{color:T.muted,fontSize:9}}>+{dayWorks.length-3} more</div>}
                {dayWorks.length>1&&bp.isMobile&&<div style={{color:T.muted,fontSize:9}}>+{dayWorks.length-1}</div>}
                {hasOverdue&&<div style={{position:"absolute",top:3,right:3,width:6,height:6,borderRadius:"50%",background:"#EF4444"}}/>}
              </div>
            );
          })}
        </div>
      </div>

      {/* Selected Day Works */}
      {selectedDay&&(
        <div style={{background:T.surface,borderRadius:14,padding:"16px 18px",border:`1px solid ${T.border}`,marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:14,color:T.text,marginBottom:12}}>
            📋 {selectedDay} {monthName} — {selectedWorks.length===0?"No deadlines":""+selectedWorks.length+" work"+(selectedWorks.length>1?"s":"")}
          </div>
          {selectedWorks.length===0&&<div style={{color:T.muted,fontSize:13}}>No deadlines on this day</div>}
          {selectedWorks.map(w=>{
            const cl=clients.find(c=>c.id===w.client_id);
            const overdue=isPast(selectedDay)&&w.status!=="Completed";
            return(
              <div key={w.id} onClick={()=>onOpenWork(w)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}`,cursor:"pointer",gap:8}}>
                <div style={{display:"flex",gap:10,alignItems:"center",minWidth:0}}>
                  <div style={{width:10,height:10,borderRadius:"50%",background:STATUS_COLOR[w.status]||"#6B7280",flexShrink:0}}/>
                  <div style={{minWidth:0}}>
                    <div style={{color:T.text,fontWeight:600,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{w.title}</div>
                    <div style={{color:T.muted,fontSize:11}}>{cl?.name} · {w.category}</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
                  {overdue&&<span style={{background:"#EF444422",color:"#EF4444",borderRadius:20,padding:"2px 8px",fontSize:10,fontWeight:700}}>Overdue</span>}
                  <span style={{background:STATUS_COLOR[w.status]+"22",color:STATUS_COLOR[w.status],border:`1px solid ${STATUS_COLOR[w.status]}44`,borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:700}}>{w.status}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Month Summary */}
      <div style={{display:"grid",gridTemplateColumns:bp.isMobile?"repeat(2,1fr)":"repeat(4,1fr)",gap:10}}>
        {[
          {label:"This Month Deadlines",value:works.filter(w=>{const d=new Date(w.deadline);return d.getMonth()===month&&d.getFullYear()===year;}).length,color:AC},
          {label:"Completed",value:works.filter(w=>{const d=new Date(w.deadline);return d.getMonth()===month&&d.getFullYear()===year&&w.status==="Completed";}).length,color:"#22C55E"},
          {label:"Overdue",value:works.filter(w=>w.deadline&&new Date(w.deadline)<new Date()&&w.status!=="Completed").length,color:"#EF4444"},
          {label:"Upcoming",value:works.filter(w=>{const d=new Date(w.deadline);return d>new Date()&&d.getMonth()===month&&d.getFullYear()===year;}).length,color:"#F59E0B"},
        ].map(({label,value,color})=>(
          <div key={label} style={{background:T.surface,borderRadius:12,padding:"14px",border:`1px solid ${T.border}`,textAlign:"center"}}>
            <div style={{color,fontWeight:900,fontSize:22}}>{value}</div>
            <div style={{color:T.muted,fontSize:11,marginTop:3}}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Onboarding Flow ───────────────────────────────────────────────────────────
function OnboardingFlow({T,bp,user,onComplete,onAddClient,onAddWork,accentColor}){
  const AC=accentColor||"#6C63FF";
  const [step,setStep]=useState(0);
  const [bizName,setBizName]=useState("");
  const [profession,setProfession]=useState("");
  const [clientName,setClientName]=useState("");
  const [clientPhone,setClientPhone]=useState("");
  const inp={background:T.card,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"12px 14px",fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",fontFamily:"inherit"};

  const PROFESSIONS=["Video Editor","Graphic Designer","Web Developer","Photographer","Content Creator","Social Media Manager","UI/UX Designer","Motion Designer","Copywriter","Illustrator","Other"];

  const steps=[
    {title:"Welcome to Workflow! 👋",sub:"Let's set up your workspace in 3 quick steps"},
    {title:"About Your Business 🏢",sub:"This helps personalise your invoices and profile"},
    {title:"Add Your First Client 👤",sub:"Who do you work with? Add them now"},
    {title:"You're all set! 🎉",sub:"Your workspace is ready to go"},
  ];

  const progressPct=(step/3)*100;

  return(
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'Inter',system-ui,sans-serif"}}>
      <div style={{width:"100%",maxWidth:480}}>
        {/* Progress bar */}
        <div style={{background:T.card,borderRadius:4,height:4,marginBottom:32,overflow:"hidden"}}>
          <div style={{background:AC,height:"100%",width:`${progressPct}%`,borderRadius:4,transition:"width 0.4s"}}/>
        </div>

        <div style={{background:T.surface,borderRadius:20,padding:bp.isMobile?"24px":"32px",border:`1px solid ${T.border}`}}>
          {/* Step indicator */}
          <div style={{display:"flex",gap:8,marginBottom:24}}>
            {[0,1,2,3].map(i=>(
              <div key={i} style={{flex:1,height:4,borderRadius:2,background:i<=step?AC:T.card,transition:"background 0.3s"}}/>
            ))}
          </div>

          <div style={{textAlign:"center",marginBottom:28}}>
            <div style={{fontSize:48,marginBottom:12}}>
              {step===0?"🚀":step===1?"🏢":step===2?"👤":"🎉"}
            </div>
            <div style={{color:T.text,fontWeight:800,fontSize:bp.isMobile?20:24,marginBottom:8}}>{steps[step].title}</div>
            <div style={{color:T.muted,fontSize:14}}>{steps[step].sub}</div>
          </div>

          {/* Step 0 — Welcome */}
          {step===0&&(
            <div style={{textAlign:"center"}}>
              <div style={{background:T.card,borderRadius:14,padding:"16px 20px",marginBottom:20,textAlign:"left"}}>
                {[["📋","Track all your clients and works"],["📤","Send WhatsApp updates in 1 click"],["🧾","Generate professional invoices"],["📊","See your revenue and analytics"],["📅","Never miss a deadline again"]].map(([icon,text])=>(
                  <div key={text} style={{display:"flex",gap:12,alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
                    <span style={{fontSize:20,flexShrink:0}}>{icon}</span>
                    <span style={{color:T.text,fontSize:13}}>{text}</span>
                  </div>
                ))}
              </div>
              <button onClick={()=>setStep(1)} style={{background:AC,color:"#fff",border:"none",borderRadius:12,padding:"14px 32px",fontWeight:700,fontSize:16,cursor:"pointer",width:"100%"}}>
                Get Started →
              </button>
              <button onClick={onComplete} style={{background:"none",border:"none",color:T.muted,fontSize:12,cursor:"pointer",marginTop:12}}>Skip setup</button>
            </div>
          )}

          {/* Step 1 — Business */}
          {step===1&&(
            <div>
              <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:24}}>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>YOUR NAME / BUSINESS NAME</div>
                  <input style={inp} placeholder="e.g. Noman Khan Creative" value={bizName} onChange={e=>setBizName(e.target.value)} autoFocus/>
                </div>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:8,letterSpacing:"0.06em"}}>WHAT DO YOU DO?</div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
                    {PROFESSIONS.map(p=>(
                      <button key={p} onClick={()=>setProfession(p)}
                        style={{background:profession===p?AC+"22":T.card,color:profession===p?AC:T.muted,border:`1.5px solid ${profession===p?AC:T.border}`,borderRadius:10,padding:"10px 8px",fontSize:12,fontWeight:600,cursor:"pointer",textAlign:"center"}}>
                        {p}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <button onClick={()=>setStep(0)} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"13px",fontWeight:600,fontSize:14,cursor:"pointer"}}>← Back</button>
                <button onClick={()=>{if(bizName.trim()){lsSet("wf_biz",{name:bizName,tagline:profession});setStep(2);}}} style={{background:AC,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14,cursor:"pointer",opacity:bizName.trim()?1:0.5}}>Next →</button>
              </div>
            </div>
          )}

          {/* Step 2 — First Client */}
          {step===2&&(
            <div>
              <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:24}}>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>CLIENT NAME *</div>
                  <input style={inp} placeholder="e.g. ABC Company" value={clientName} onChange={e=>setClientName(e.target.value)} autoFocus/>
                </div>
                <div>
                  <div style={{color:T.muted,fontSize:11,fontWeight:700,marginBottom:5,letterSpacing:"0.06em"}}>PHONE NUMBER</div>
                  <input style={inp} placeholder="Client's phone" type="tel" value={clientPhone} onChange={e=>setClientPhone(e.target.value)}/>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <button onClick={()=>setStep(1)} style={{background:"none",border:`1px solid ${T.border}`,color:T.muted,borderRadius:12,padding:"13px",fontWeight:600,fontSize:14,cursor:"pointer"}}>← Back</button>
                <button onClick={async()=>{
                  if(clientName.trim()){
                    await onAddClient({name:clientName.trim(),phone:clientPhone,email:"",company:"",notes:""});
                  }
                  setStep(3);
                }} style={{background:AC,color:"#fff",border:"none",borderRadius:12,padding:"13px",fontWeight:700,fontSize:14,cursor:"pointer",opacity:clientName.trim()?1:0.5}}>
                  {clientName.trim()?"Add Client →":"Skip →"}
                </button>
              </div>
              {!clientName.trim()&&<div style={{color:T.muted,fontSize:11,textAlign:"center",marginTop:8}}>You can add clients later too</div>}
            </div>
          )}

          {/* Step 3 — Done */}
          {step===3&&(
            <div style={{textAlign:"center"}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10,marginBottom:24}}>
                {[["🎯","Your first client added"],["📋","Ready to create works"],["🧾","Invoices ready to send"],["📊","Analytics tracking started"]].map(([icon,text])=>(
                  <div key={text} style={{background:T.card,borderRadius:12,padding:"14px 10px",textAlign:"center"}}>
                    <div style={{fontSize:24,marginBottom:6}}>{icon}</div>
                    <div style={{color:T.muted,fontSize:11}}>{text}</div>
                  </div>
                ))}
              </div>
              <button onClick={onComplete} style={{background:AC,color:"#fff",border:"none",borderRadius:12,padding:"14px 32px",fontWeight:700,fontSize:16,cursor:"pointer",width:"100%"}}>
                Open Workflow 🚀
              </button>
            </div>
          )}
        </div>

        {/* Step dots */}
        <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:20}}>
          {[0,1,2,3].map(i=>(
            <div key={i} style={{width:i===step?24:8,height:8,borderRadius:4,background:i===step?AC:T.border,transition:"all 0.3s"}}/>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── GST Invoice Generator ─────────────────────────────────────────────────────
function generateGSTInvoice(work, client, businessProfile, invoiceDefaults, timerDisplay){
  const biz=businessProfile||{};
  const inv=invoiceDefaults||{};
  const invoiceNo=`INV-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;
  const date=new Date().toLocaleDateString("en-IN");
  const dueDate=new Date(Date.now()+(parseInt(inv.dueDays||7))*86400000).toLocaleDateString("en-IN");
  const subtotal=work.budget||0;
  const isIGST=true; // interstate by default
  const gstRate=18;
  const gstAmt=Math.round(subtotal*gstRate/100);
  const cgstAmt=Math.round(gstAmt/2);
  const sgstAmt=Math.round(gstAmt/2);
  const total=subtotal+(isIGST?gstAmt:gstAmt);
  const advance=work.advance||0;
  const balance=work.paid?0:(total-advance);

  const html=`<!DOCTYPE html>
<html><head><title>${invoiceNo}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Segoe UI',Arial,sans-serif;color:#1a1a1a;background:#fff;padding:0}
.page{max-width:800px;margin:0 auto;padding:40px}
.header{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:24px;border-bottom:3px solid #6C63FF;margin-bottom:28px}
.logo{font-size:24px;font-weight:900;color:#6C63FF;letter-spacing:-0.5px}
.logo small{display:block;font-size:12px;font-weight:400;color:#6b7280;margin-top:2px}
.inv-details{text-align:right}
.inv-no{font-size:22px;font-weight:800;color:#1a1a1a}
.badge{display:inline-block;padding:4px 14px;border-radius:20px;font-size:12px;font-weight:700;margin-top:6px}
.paid-badge{background:#22C55E22;color:#22C55E;border:1px solid #22C55E44}
.pending-badge{background:#EF444422;color:#EF4444;border:1px solid #EF444444}
.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:32px;margin-bottom:28px}
.info-box h4{font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:8px}
.info-box p{font-size:13px;color:#374151;line-height:1.7}
.info-box strong{color:#1a1a1a;font-size:15px}
table{width:100%;border-collapse:collapse;margin-bottom:0}
thead{background:#f8f9ff}
th{padding:10px 14px;text-align:left;font-size:11px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.05em}
td{padding:12px 14px;border-bottom:1px solid #f3f4f6;font-size:13px;color:#374151}
.right{text-align:right}
.total-section{background:#f8f9ff;border-top:2px solid #e5e7eb}
.total-section td{font-weight:600;color:#1a1a1a;padding:10px 14px}
.grand-total td{background:#6C63FF;color:#fff!important;font-weight:800;font-size:15px}
.gst-note{font-size:11px;color:#6b7280;margin-top:6px}
.payment-section{margin-top:28px;padding:20px;background:#f8f9ff;border-radius:12px;border:1px solid #e5e7eb}
.payment-section h4{font-size:12px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:12px}
.pay-grid{display:grid;grid-template-columns:1fr 1fr;gap:20px}
.pay-item p{font-size:11px;color:#6b7280;margin-bottom:2px}
.pay-item strong{font-size:13px;color:#1a1a1a}
.footer{margin-top:28px;padding-top:20px;border-top:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:flex-end}
.footer-note{font-size:12px;color:#6b7280;line-height:1.6}
.sign-box{text-align:right}
.sign-box p{font-size:11px;color:#6b7280}
.sign-box strong{font-size:13px;color:#1a1a1a;display:block;margin-top:24px;border-top:1px solid #d1d5db;padding-top:6px}
@media print{.page{padding:20px}}
</style></head>
<body><div class="page">

<div class="header">
  <div class="logo">
    ◈ ${biz.name||"Workflow"}
    <small>${biz.tagline||"Freelancer Project Management"}</small>
    ${biz.phone?`<small>${biz.phone}</small>`:""}
    ${biz.email?`<small>${biz.email}</small>`:""}
    ${biz.address?`<small>${biz.address}</small>`:""}
    ${biz.gstin?`<small>GSTIN: ${biz.gstin}</small>`:""}
  </div>
  <div class="inv-details">
    <div class="inv-no">${invoiceNo}</div>
    <div style="font-size:12px;color:#6b7280;margin-top:4px">Date: ${date}</div>
    <div style="font-size:12px;color:#6b7280">Due: ${dueDate}</div>
    <span class="badge ${work.paid?"paid-badge":"pending-badge"}">${work.paid?"✓ PAID":"PAYMENT PENDING"}</span>
  </div>
</div>

<div class="info-grid">
  <div class="info-box">
    <h4>From</h4>
    <p><strong>${biz.name||"Your Business"}</strong><br>
    ${biz.address||""}<br>
    ${biz.gstin?`GSTIN: ${biz.gstin}`:""}
    </p>
  </div>
  <div class="info-box">
    <h4>Bill To</h4>
    <p><strong>${client?.name||"Client"}</strong><br>
    ${client?.company?client.company+"<br>":""}
    ${client?.phone?`📱 ${client.phone}<br>`:""}
    ${client?.email?`✉️ ${client.email}`:""}
    </p>
  </div>
</div>

<table>
  <thead><tr><th>Description</th><th>Category</th><th>Time Tracked</th><th class="right">Amount</th></tr></thead>
  <tbody>
    <tr>
      <td><strong>${work.title}</strong>${work.description?`<br><span style="font-size:11px;color:#6b7280">${work.description}</span>`:""}</td>
      <td>${work.category||"—"}</td>
      <td>${timerDisplay||"—"}</td>
      <td class="right">₹${subtotal.toLocaleString()}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="total-section"><td colspan="3">Subtotal</td><td class="right">₹${subtotal.toLocaleString()}</td></tr>
    ${isIGST
      ?`<tr class="total-section"><td colspan="3">IGST @ ${gstRate}%</td><td class="right">₹${gstAmt.toLocaleString()}</td></tr>`
      :`<tr class="total-section"><td colspan="3">CGST @ ${gstRate/2}%</td><td class="right">₹${cgstAmt.toLocaleString()}</td></tr>
       <tr class="total-section"><td colspan="3">SGST @ ${gstRate/2}%</td><td class="right">₹${sgstAmt.toLocaleString()}</td></tr>`
    }
    <tr class="grand-total"><td colspan="3"><strong>Total Amount</strong></td><td class="right"><strong>₹${total.toLocaleString()}</strong></td></tr>
    <tr class="total-section"><td colspan="3">Advance Received</td><td class="right" style="color:#22C55E">₹${advance.toLocaleString()}</td></tr>
    <tr class="total-section" style="background:#fff5f5"><td colspan="3"><strong>Balance Due</strong></td><td class="right" style="color:${work.paid?"#22C55E":"#EF4444"}"><strong>₹${balance.toLocaleString()}</strong></td></tr>
  </tfoot>
</table>
<p class="gst-note">* GST charged as per applicable tax laws. Subject to jurisdiction.</p>

${(inv.upiId||inv.bankName)?`
<div class="payment-section">
  <h4>Payment Details</h4>
  <div class="pay-grid">
    ${inv.upiId?`<div class="pay-item"><p>UPI ID</p><strong>${inv.upiId}</strong></div>`:""}
    ${inv.bankName?`<div class="pay-item"><p>Bank Name</p><strong>${inv.bankName}</strong></div>`:""}
    ${inv.accountNo?`<div class="pay-item"><p>Account Number</p><strong>${inv.accountNo}</strong></div>`:""}
    ${inv.ifsc?`<div class="pay-item"><p>IFSC Code</p><strong>${inv.ifsc}</strong></div>`:""}
  </div>
  ${inv.terms?`<p style="font-size:12px;color:#6b7280;margin-top:12px;padding-top:10px;border-top:1px solid #e5e7eb">${inv.terms}</p>`:""}
</div>`:""}

<div class="footer">
  <div class="footer-note">
    ${inv.footer||"Thank you for your business!"}<br>
    <span style="font-size:11px">Generated by ◈ ${biz.name||"Workflow"} · ${new Date().toLocaleString("en-IN")} · workflow.loytro.com</span>
  </div>
  <div class="sign-box">
    <p>Authorised Signatory</p>
    <strong>${biz.name||"Your Business"}</strong>
  </div>
</div>

</div></body></html>`;

  const win=window.open("","_blank");
  win.document.write(html);
  win.document.close();
  setTimeout(()=>win.print(),500);
}
